(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9345],{

/***/ 84266:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[productVariantIdentifier]/[instanceId]",
      function () {
        return __webpack_require__(51046);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useAccountManageWallet; }
/* harmony export */ });
/* harmony import */ var _useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18060);

var useAccountManageWallet = (0,_useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__/* .useLanguageDependentDataSSr */ .Y)("account-manage-wallet");


/***/ }),

/***/ 25977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _error_error_message__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63879);
/* harmony import */ var _typography_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28773);
/* harmony import */ var _checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38434);
/* harmony import */ var _checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var Checkbox = function(_param) {
    var name = _param.name, children = _param.children, register = _param.register, errorMessage = _param.errorMessage, inverted = _param.inverted, className = _param.className, inputProps = _objectWithoutProperties(_param, [
        "name",
        "children",
        "register",
        "errorMessage",
        "inverted",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "data-testid": "checkbox",
        className: "".concat(className, " ").concat((_checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["checkbox-wrapper"]), " ").concat(inputProps.disabled ? (_checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4___default().disabled) : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: (_checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({}, register(name), inputProps, {
                        type: "checkbox"
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        style: {
                            borderColor: inverted ? "#fff" : "#000"
                        },
                        className: (_checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4___default().checkmark)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
                        inverted: inverted,
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_error_error_message__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .B, {
                className: (_checkbox_module_scss__WEBPACK_IMPORTED_MODULE_4___default().error),
                children: errorMessage
            })
        ]
    });
};



/***/ }),

/***/ 58523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ StageImageButtonToken; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _assets_creatoki_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13692);
/* harmony import */ var _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92212);
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93217);
/* harmony import */ var _stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43067);
/* harmony import */ var _stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _link_link_base_link_base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27397);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var StageImageButtonToken = function(_param) {
    var image = _param.image, editButtonProps = _param.editButtonProps, shadow = _param.shadow, props = _objectWithoutProperties(_param, [
        "image",
        "editButtonProps",
        "shadow"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), src = ref[0], setSrc = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setSrc("".concat(image, "?resolution=thumbnail"));
    }, [
        image
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["stage-image-button-token"]),
        children: [
            (props === null || props === void 0 ? void 0 : props.hasLink) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_link_link_base_link_base__WEBPACK_IMPORTED_MODULE_5__/* .LinkBase */ .w, {
                className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["stage-image-button-token-link"]),
                href: props.href,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, _objectSpread({}, props, {
                    variant: shadow ? _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.STAGE */ .l.STAGE : _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.SECONDARY_FILLED */ .l.SECONDARY_FILLED,
                    className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["token-button"]),
                    icon: {
                        element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: src,
                            onError: function() {
                                return setSrc(_assets_creatoki_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src);
                            }
                        }),
                        align: "left"
                    },
                    buttonUrl: ""
                }))
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, _objectSpread({}, props, {
                variant: shadow ? _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.STAGE */ .l.STAGE : _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.SECONDARY_FILLED */ .l.SECONDARY_FILLED,
                className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["token-button"]),
                icon: {
                    element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: src,
                        onError: function() {
                            return setSrc(_assets_creatoki_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src);
                        }
                    }),
                    align: "left"
                },
                buttonUrl: ""
            })),
            editButtonProps && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, _objectSpread({}, editButtonProps, {
                className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default().editButton)
            }))
        ]
    });
};



/***/ }),

/***/ 51046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _instanceId_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(80880);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/api/hooks/useAccountManageWallet.hook.ts
var useAccountManageWallet_hook = __webpack_require__(93165);
// EXTERNAL MODULE: ./src/api/hooks/useContextSSr.hook.ts
var useContextSSr_hook = __webpack_require__(63794);
// EXTERNAL MODULE: ./src/api/hooks/useFooter.hook.ts
var useFooter_hook = __webpack_require__(47536);
// EXTERNAL MODULE: ./src/api/hooks/useFullVariantByIdSsr.hook.ts
var useFullVariantByIdSsr_hook = __webpack_require__(34172);
// EXTERNAL MODULE: ./src/api/hooks/useLanguageDependentDataSsr.hook.ts
var useLanguageDependentDataSsr_hook = __webpack_require__(18060);
;// CONCATENATED MODULE: ./src/api/hooks/useInstanceDetail.hook.tsx

var useInstanceDetailPage = (0,useLanguageDependentDataSsr_hook/* useLanguageDependentDataSSr */.Y)("instance-detail-page");

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next-data-hooks/index.esm.js
var index_esm = __webpack_require__(4118);
// EXTERNAL MODULE: ./src/api/services/instances.service.tsx
var instances_service = __webpack_require__(21804);
;// CONCATENATED MODULE: ./src/api/hooks/useInstanceMetaByUrlSsr.hook.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var useInstanceMetaByUrlSsr = (0,index_esm/* createDataHook */.Qo)("instance-meta-by-url", function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(context) {
        var ref, instanceId, instanceService, instanceResponse, instanceMetaResponse;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    instanceId = context === null || context === void 0 ? void 0 : (ref = context.params) === null || ref === void 0 ? void 0 : ref.instanceId;
                    if (instanceId) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 4:
                    instanceService = new instances_service/* default */.Z();
                    _ctx.next = 7;
                    return instanceService.getInstancesById(instanceId);
                case 7:
                    instanceResponse = _ctx.sent;
                    _ctx.next = 10;
                    return instanceService.getJsonMetaDataByMetaUrl(instanceResponse.data.metaUrl);
                case 10:
                    instanceMetaResponse = _ctx.sent;
                    return _ctx.abrupt("return", instanceMetaResponse);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(context) {
        return _ref.apply(this, arguments);
    };
}());

// EXTERNAL MODULE: ./src/api/hooks/useVariantDetailPage.hook.ts
var useVariantDetailPage_hook = __webpack_require__(50167);
// EXTERNAL MODULE: ./src/api/models/variant-image-type.tsx
var variant_image_type = __webpack_require__(84623);
// EXTERNAL MODULE: ./src/components/_shared/accordion/accordion.tsx
var accordion = __webpack_require__(85256);
// EXTERNAL MODULE: ./src/components/_shared/breadcrumbs/breadcrumbs.tsx
var breadcrumbs = __webpack_require__(10884);
// EXTERNAL MODULE: ./src/utils/_enums/typeography-variants.enum.tsx
var typeography_variants_enum = __webpack_require__(77872);
// EXTERNAL MODULE: ./src/utils/_helper/time-helper.tsx
var time_helper = __webpack_require__(28508);
// EXTERNAL MODULE: ./src/utils/_hooks/hooks.tsx
var hooks = __webpack_require__(62251);
// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/components/_shared/generic-attribute-box/generic-attribute-box.module.scss
var generic_attribute_box_module = __webpack_require__(76012);
var generic_attribute_box_module_default = /*#__PURE__*/__webpack_require__.n(generic_attribute_box_module);
;// CONCATENATED MODULE: ./src/components/_shared/generic-attribute-box/generic-attribute-box.tsx










var GenericAttributeList = function(props) {
    var ref, ref1, ref2, ref3;
    var instance = (0,hooks/* useAppSelector */.C)(function(state) {
        return {
            instance: state.productSlice.instance
        };
    }).instance;
    var data = (0,useVariantDetailPage_hook/* useVariantDetailPage */.l)();
    var router = (0,client_router.useRouter)();
    var variant = (0,useFullVariantByIdSsr_hook/* useFullVariantByIdSsr */.Q)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING4_BOLD */.H.HEADING4_BOLD,
                className: (generic_attribute_box_module_default()).headline,
                children: props.headline
            }),
            data.resale && (instance === null || instance === void 0 ? void 0 : instance.saleStartDate) || data.resale && (variant === null || variant === void 0 ? void 0 : variant.salesAttribute.saleFrom) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (generic_attribute_box_module_default())["attribute-column"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        children: data.resale
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: typeography_variants_enum/* TypographyVariantsEnum.MOBILENAVLINK */.H.MOBILENAVLINK,
                        children: (0,time_helper/* formatDateAndTime */.sb)(!instance || !router.query.instanceId || !instance.saleStartDate ? variant === null || variant === void 0 ? void 0 : variant.salesAttribute.saleFrom : instance.saleStartDate)
                    })
                ]
            }) : null,
            (data === null || data === void 0 ? void 0 : data.salesEnd) && (variant === null || variant === void 0 ? void 0 : (ref = variant.salesAttribute) === null || ref === void 0 ? void 0 : ref.saleTo) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (generic_attribute_box_module_default())["attribute-column"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        children: data === null || data === void 0 ? void 0 : data.salesEnd
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: typeography_variants_enum/* TypographyVariantsEnum.MOBILENAVLINK */.H.MOBILENAVLINK,
                        children: (0,time_helper/* formatDateAndTime */.sb)(variant === null || variant === void 0 ? void 0 : (ref1 = variant.salesAttribute) === null || ref1 === void 0 ? void 0 : ref1.saleTo)
                    })
                ]
            }) : null,
            props.attributes.map(function(attr) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (generic_attribute_box_module_default())["attribute-column"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                            children: attr.label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                            variant: typeography_variants_enum/* TypographyVariantsEnum.MOBILENAVLINK */.H.MOBILENAVLINK,
                            children: attr.value
                        })
                    ]
                }, attr.label);
            }),
            data.series && (variant === null || variant === void 0 ? void 0 : (ref2 = variant.product) === null || ref2 === void 0 ? void 0 : ref2.seriesName) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (generic_attribute_box_module_default())["attribute-column"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        children: data.series
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: typeography_variants_enum/* TypographyVariantsEnum.MOBILENAVLINK */.H.MOBILENAVLINK,
                        children: variant === null || variant === void 0 ? void 0 : (ref3 = variant.product) === null || ref3 === void 0 ? void 0 : ref3.seriesName
                    })
                ]
            }) : null,
            (data === null || data === void 0 ? void 0 : data.episode) && variant.product.episode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (generic_attribute_box_module_default())["attribute-column"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        children: data === null || data === void 0 ? void 0 : data.episode
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: typeography_variants_enum/* TypographyVariantsEnum.MOBILENAVLINK */.H.MOBILENAVLINK,
                        children: variant.product.episode
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var generic_attribute_box = (GenericAttributeList);

// EXTERNAL MODULE: ./src/components/_shared/header/default-header/default-header.tsx + 9 modules
var default_header = __webpack_require__(4302);
// EXTERNAL MODULE: ./src/components/_shared/header-footer-wrapper/header-footer-wrapper.tsx
var header_footer_wrapper = __webpack_require__(3143);
// EXTERNAL MODULE: ./src/components/_shared/meta-tags-resolver/meta-tags-resolver.tsx
var meta_tags_resolver = __webpack_require__(66743);
// EXTERNAL MODULE: ./src/api/hooks/useGlobal.hook.ts
var useGlobal_hook = __webpack_require__(77459);
// EXTERNAL MODULE: ./src/api/models/instance-status.tsx
var instance_status = __webpack_require__(23812);
// EXTERNAL MODULE: ./src/utils/_enums/response-codes.enum.ts
var response_codes_enum = __webpack_require__(23430);
// EXTERNAL MODULE: ./src/utils/_enums/sales-type.tsx
var sales_type = __webpack_require__(9943);
// EXTERNAL MODULE: ./src/components/_shared/login-dialog/login-dialog.tsx
var login_dialog = __webpack_require__(16308);
// EXTERNAL MODULE: ./src/components/_shared/sales-box/_shared/sales-box-footer/sales-box-footer.tsx
var sales_box_footer = __webpack_require__(25834);
// EXTERNAL MODULE: ./src/redux/slices/resale-slice.tsx
var resale_slice = __webpack_require__(69376);
// EXTERNAL MODULE: ./src/utils/_enums/button-variants.enum.tsx
var button_variants_enum = __webpack_require__(92212);
// EXTERNAL MODULE: ./src/utils/_helper/locale-helper.tsx
var locale_helper = __webpack_require__(50325);
// EXTERNAL MODULE: ./src/components/_shared/button/button.tsx
var button_button = __webpack_require__(93217);
// EXTERNAL MODULE: ./src/components/_shared/wallet-connect-button/wallet-connect-button.tsx
var wallet_connect_button = __webpack_require__(30613);
// EXTERNAL MODULE: ./src/components/_shared/sales-box/connect-wallet/sales-box-connect-wallet.module.scss
var sales_box_connect_wallet_module = __webpack_require__(90870);
var sales_box_connect_wallet_module_default = /*#__PURE__*/__webpack_require__.n(sales_box_connect_wallet_module);
;// CONCATENATED MODULE: ./src/components/_shared/sales-box/connect-wallet/sales-box-connect-wallet.tsx









var SalesBoxConnectWallet = function() {
    var ref, ref1, ref2;
    var data = useInstanceDetailPage();
    var ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (sales_box_connect_wallet_module_default())["connect-wallet-wrapper"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                variant: typeography_variants_enum/* TypographyVariantsEnum.BODY_SMALL */.H.BODY_SMALL,
                children: (ref3 = data === null || data === void 0 ? void 0 : (ref = data.walletNotConnectedText) === null || ref === void 0 ? void 0 : ref.content) !== null && ref3 !== void 0 ? ref3 : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (sales_box_connect_wallet_module_default())["button-wrapper"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: data === null || data === void 0 ? void 0 : (ref1 = data.createWallet) === null || ref1 === void 0 ? void 0 : ref1.buttonUrl,
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                                children: (ref4 = data === null || data === void 0 ? void 0 : (ref2 = data.createWallet) === null || ref2 === void 0 ? void 0 : ref2.buttonText) !== null && ref4 !== void 0 ? ref4 : ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (sales_box_connect_wallet_module_default())["wallet-connect-button"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(wallet_connect_button/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var sales_box_connect_wallet = (SalesBoxConnectWallet);

// EXTERNAL MODULE: ./src/components/_shared/sales-box/cancel-resale-box/cancel-resale-box.module.scss
var cancel_resale_box_module = __webpack_require__(76291);
var cancel_resale_box_module_default = /*#__PURE__*/__webpack_require__.n(cancel_resale_box_module);
;// CONCATENATED MODULE: ./src/components/_shared/sales-box/cancel-resale-box/cancel-resale-box.tsx














var CancelResaleBox = function(props) {
    var data = useInstanceDetailPage();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(false), cancelConfirm = ref[0], setCancelConfirm = ref[1];
    var ref1 = (0,hooks/* useAppSelector */.C)(function(state) {
        return {
            instance: state.productSlice.instance,
            walletId: state.blockchainSlice.walletId,
            cancelFixPriceModel: state.resaleSlice.cancelFixPriceModel
        };
    }), instance = ref1.instance, walletId = ref1.walletId, cancelFixPriceModel = ref1.cancelFixPriceModel;
    (0,react.useEffect)(function() {
        if (cancelFixPriceModel.status && cancelFixPriceModel.status !== 200) {
            dispatch((0,resale_slice/* removeCancelFixPriceStatus */.K$)());
        }
    }, [
        cancelFixPriceModel.status
    ]);
    var cancelResale = function() {
        if (instance) {
            dispatch((0,resale_slice/* cancelFixPrice */.HB)(instance.id));
        }
    };
    if (instance && data) {
        var ref2, ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: walletId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: walletId === instance.ownerWallet ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: cancelConfirm ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (cancel_resale_box_module_default())["confirm-cancel-sale"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                className: (cancel_resale_box_module_default())["sales-type"],
                                element: "span",
                                children: data.confimCancelSale.content
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (cancel_resale_box_module_default())["cancel-sale-actions"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                        variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                                        className: (cancel_resale_box_module_default())["cancel-button"],
                                        disabled: cancelFixPriceModel.pending,
                                        onClick: function() {
                                            return setCancelConfirm(false);
                                        },
                                        children: data.backButton.buttonText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                        className: (cancel_resale_box_module_default())["cancel-button"],
                                        disabled: (instance === null || instance === void 0 ? void 0 : instance.status) !== instance_status/* InstanceStatus.OPEN */.O.OPEN,
                                        pending: cancelFixPriceModel.pending,
                                        onClick: cancelResale,
                                        children: data.cancelSaleButton.buttonText
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                className: (cancel_resale_box_module_default())["sales-type"],
                                element: "span",
                                children: instance.status === instance_status/* InstanceStatus.OPEN */.O.OPEN ? data === null || data === void 0 ? void 0 : (ref2 = data.cancelSaleDescription) === null || ref2 === void 0 ? void 0 : ref2.content : data === null || data === void 0 ? void 0 : (ref3 = data.cannotCancelSaleDescription) === null || ref3 === void 0 ? void 0 : ref3.content
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (cancel_resale_box_module_default())["fixed-price-sale"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (cancel_resale_box_module_default())["fixed-price-left-wrapper"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                className: (cancel_resale_box_module_default())["on-sale-for"],
                                                children: data.onSaleForPrice.content
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING3_BOLD */.H.HEADING3_BOLD,
                                                element: "span",
                                                className: "".concat((cancel_resale_box_module_default())["main-price"], " ").concat((cancel_resale_box_module_default()).price),
                                                children: (0,locale_helper/* getLocaleEthPrice */.af)(props.instance.priceEth) + "\u039E"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                className: "".concat((cancel_resale_box_module_default())["secondary-resale-price"], " ").concat((cancel_resale_box_module_default()).price),
                                                variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING5_LIGHT */.H.HEADING5_LIGHT,
                                                element: "span",
                                                children: "(".concat((0,locale_helper/* getLocalePrice */.yb)(props.instance.priceFiat), "\u20AC)")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (cancel_resale_box_module_default())["fixed-price-right-wrapper"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                            onClick: function() {
                                                return setCancelConfirm(true);
                                            },
                                            disabled: (instance === null || instance === void 0 ? void 0 : instance.status) !== instance_status/* InstanceStatus.OPEN */.O.OPEN,
                                            className: (cancel_resale_box_module_default())["fixed-price-buy"],
                                            children: data.abortResaleHeadline.headlineContent
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    className: (cancel_resale_box_module_default())["connect-wallet-wrapper"],
                    children: data.correctAccountWrongWalletPrompt.content
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (cancel_resale_box_module_default())["connect-wallet-wrapper"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sales_box_connect_wallet, {})
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
/* harmony default export */ var cancel_resale_box = (CancelResaleBox);

// EXTERNAL MODULE: ./src/components/_shared/sales-box/_shared/price-box/price-box.tsx
var price_box = __webpack_require__(69557);
// EXTERNAL MODULE: ./src/components/_shared/sales-box/_shared/transaction-fee-box/transaction-fee-box.tsx + 1 modules
var transaction_fee_box = __webpack_require__(42154);
// EXTERNAL MODULE: ./src/components/_shared/sales-box/fixed-price-sale/fixed-price-sale.module.scss
var fixed_price_sale_module = __webpack_require__(85535);
var fixed_price_sale_module_default = /*#__PURE__*/__webpack_require__.n(fixed_price_sale_module);
;// CONCATENATED MODULE: ./src/components/_shared/sales-box/fixed-price-sale/fixed-price-sale.tsx










var FixedPriceSale = function(props) {
    var data = useInstanceDetailPage();
    if (data) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        var ref10, ref11, ref12, ref13;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (fixed_price_sale_module_default())["fixed-price-sale"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (fixed_price_sale_module_default())["fixed-price-left-wrapper"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                            variant: typeography_variants_enum/* TypographyVariantsEnum.TABLE_TITLE */.H.TABLE_TITLE,
                            className: (fixed_price_sale_module_default())["sales-type"],
                            element: "span",
                            children: props.isInitial ? (ref10 = data === null || data === void 0 ? void 0 : (ref = data.initialDrop) === null || ref === void 0 ? void 0 : ref.content) !== null && ref10 !== void 0 ? ref10 : "" : (ref11 = data === null || data === void 0 ? void 0 : (ref1 = data.resale) === null || ref1 === void 0 ? void 0 : ref1.content) !== null && ref11 !== void 0 ? ref11 : ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (fixed_price_sale_module_default())["price-wrapper"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(price_box/* default */.Z, {
                                ethPrice: props.instance.priceEth,
                                fiatPrice: props.instance.priceFiat,
                                withTaxRate: props.isInitial,
                                currencies: props.isInitial ? "FIAT_AND_ETH" : "ETH"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transaction_fee_box/* default */.Z, {
                            gasUsage: 147000
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (fixed_price_sale_module_default())["fixed-price-right-wrapper"],
                    children: [
                        props.isGeoblocked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                            variant: typeography_variants_enum/* TypographyVariantsEnum.CAPTION */.H.CAPTION,
                            element: "span",
                            className: (fixed_price_sale_module_default())["geo-ip-error"],
                            children: (ref12 = data === null || data === void 0 ? void 0 : data.geoIpWarning) !== null && ref12 !== void 0 ? ref12 : ""
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                            onClick: props.onBuy,
                            disabled: (0,time_helper/* isDateInFuture */.ek)(props === null || props === void 0 ? void 0 : (ref2 = props.variant) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.salesAttribute) === null || ref3 === void 0 ? void 0 : ref3.saleFrom) || (0,time_helper/* isDateInPast */.OF)(props === null || props === void 0 ? void 0 : (ref4 = props.variant) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.salesAttribute) === null || ref5 === void 0 ? void 0 : ref5.saleTo) && !(props === null || props === void 0 ? void 0 : (ref6 = props.instance) === null || ref6 === void 0 ? void 0 : ref6.ownerWallet) && !(props === null || props === void 0 ? void 0 : (ref7 = props.instance) === null || ref7 === void 0 ? void 0 : ref7.ownerId) || (0,time_helper/* isDateInFuture */.ek)(props === null || props === void 0 ? void 0 : (ref8 = props.instance) === null || ref8 === void 0 ? void 0 : ref8.saleStartDate),
                            pending: props.pending,
                            className: (fixed_price_sale_module_default())["fixed-price-buy"],
                            children: (ref13 = data === null || data === void 0 ? void 0 : (ref9 = data.buyButton) === null || ref9 === void 0 ? void 0 : ref9.buttonText) !== null && ref13 !== void 0 ? ref13 : ""
                        })
                    ]
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
/* harmony default export */ var fixed_price_sale = (FixedPriceSale);

// EXTERNAL MODULE: ./src/redux/slices/mint-slice.tsx + 3 modules
var mint_slice = __webpack_require__(37142);
// EXTERNAL MODULE: ./src/components/_shared/sales-box/minting-box/minting-box.module.scss
var minting_box_module = __webpack_require__(37261);
var minting_box_module_default = /*#__PURE__*/__webpack_require__.n(minting_box_module);
;// CONCATENATED MODULE: ./src/components/_shared/sales-box/minting-box/minting-box.tsx















var MintingBox = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var data = useInstanceDetailPage();
    var variant = (0,useFullVariantByIdSsr_hook/* useFullVariantByIdSsr */.Q)();
    var ref14 = (0,hooks/* useAppSelector */.C)(function(state) {
        return {
            walletId: state.blockchainSlice.walletId,
            balance: state.blockchainSlice.balance,
            instance: state.productSlice.instance,
            chainId: state.blockchainSlice.chainId,
            mintInstanceModel: state.mintSlice.mintInstanceModel
        };
    }), walletId = ref14.walletId, balance = ref14.balance, instance = ref14.instance, chainId = ref14.chainId, mintInstanceModel = ref14.mintInstanceModel;
    if (data) {
        if ((instance === null || instance === void 0 ? void 0 : instance.status) === instance_status/* InstanceStatus.MINTING */.O.MINTING) {
            var ref1;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (minting_box_module_default())["minting-box"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        children: data === null || data === void 0 ? void 0 : (ref1 = data.currentlyMinting) === null || ref1 === void 0 ? void 0 : ref1.content
                    })
                })
            });
        } else {
            var ref2, ref3, ref4;
            var ref5, ref6, ref7, ref8, ref9, ref10, ref11;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (minting_box_module_default())["minting-box"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: typeography_variants_enum/* TypographyVariantsEnum.BODY_SMALL */.H.BODY_SMALL,
                        className: (minting_box_module_default())["minting-description-general"],
                        children: (ref5 = data === null || data === void 0 ? void 0 : (ref2 = data.mintingDescriptionGeneral) === null || ref2 === void 0 ? void 0 : ref2.content) !== null && ref5 !== void 0 ? ref5 : ""
                    }),
                    walletId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                className: (minting_box_module_default())["wallet-connected-text"],
                                variant: typeography_variants_enum/* TypographyVariantsEnum.BODY_SMALL */.H.BODY_SMALL,
                                children: (ref6 = data === null || data === void 0 ? void 0 : (ref3 = data.walletConnectedText) === null || ref3 === void 0 ? void 0 : ref3.content) !== null && ref6 !== void 0 ? ref6 : ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        variant: typeography_variants_enum/* TypographyVariantsEnum.BODY_SMALL */.H.BODY_SMALL,
                                        children: "".concat((ref7 = data === null || data === void 0 ? void 0 : data.walletId) !== null && ref7 !== void 0 ? ref7 : "", ":")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        variant: typeography_variants_enum/* TypographyVariantsEnum.BODY_SMALL */.H.BODY_SMALL,
                                        className: (minting_box_module_default())["bold-text"],
                                        children: walletId
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        variant: typeography_variants_enum/* TypographyVariantsEnum.BODY_SMALL */.H.BODY_SMALL,
                                        children: (ref8 = data === null || data === void 0 ? void 0 : data.availableText) !== null && ref8 !== void 0 ? ref8 : ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        variant: typeography_variants_enum/* TypographyVariantsEnum.BODY_SMALL */.H.BODY_SMALL,
                                        className: (minting_box_module_default())["bold-text"],
                                        children: balance !== undefined ? (0,locale_helper/* getLocaleEthPrice */.af)(balance) + "\u039E" : ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(transaction_fee_box/* default */.Z, {
                                gasUsage: 87000
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        variant: typeography_variants_enum/* TypographyVariantsEnum.BODY_SMALL */.H.BODY_SMALL,
                                        className: (minting_box_module_default())["error-message"],
                                        children: chainId !== Number("1") ? (ref9 = data === null || data === void 0 ? void 0 : data.networkErrorMessage) !== null && ref9 !== void 0 ? ref9 : "" : !balance ? (ref10 = data === null || data === void 0 ? void 0 : data.mintingErrorMessage) !== null && ref10 !== void 0 ? ref10 : "" : ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                        className: (minting_box_module_default())["mint-nft-button"],
                                        disabled: !balance || chainId !== Number("1"),
                                        pending: mintInstanceModel.pending,
                                        onClick: function() {
                                            if (instance && variant) {
                                                var ref, ref12;
                                                var ref13;
                                                dispatch((0,mint_slice/* mintInstance */.P8)({
                                                    tokenContractAddress: (ref13 = (ref = variant.salesAttribute) === null || ref === void 0 ? void 0 : (ref12 = ref.contract) === null || ref12 === void 0 ? void 0 : ref12.contractAddress) !== null && ref13 !== void 0 ? ref13 : "",
                                                    instanceId: instance.id,
                                                    walletAddress: walletId
                                                }));
                                            }
                                        },
                                        children: (ref11 = data === null || data === void 0 ? void 0 : (ref4 = data.mintNFT) === null || ref4 === void 0 ? void 0 : ref4.buttonText) !== null && ref11 !== void 0 ? ref11 : ""
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sales_box_connect_wallet, {})
                    })
                ]
            });
        }
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
/* harmony default export */ var minting_box = (MintingBox);

// EXTERNAL MODULE: ./src/utils/_enums/route-path.enum.tsx
var route_path_enum = __webpack_require__(16837);
// EXTERNAL MODULE: ./src/components/_shared/sales-box/not-available-nft/not-available-nft.module.scss
var not_available_nft_module = __webpack_require__(35170);
var not_available_nft_module_default = /*#__PURE__*/__webpack_require__.n(not_available_nft_module);
;// CONCATENATED MODULE: ./src/components/_shared/sales-box/not-available-nft/not-available-nft.tsx












var NotAvailableNft = function() {
    var data = useInstanceDetailPage();
    var jwt = (0,hooks/* useAppSelector */.C)(function(state) {
        return state.authentification.jwt;
    });
    var walletId = (0,hooks/* useAppSelector */.C)(function(state) {
        return state.blockchainSlice.walletId;
    });
    var router = (0,client_router.useRouter)();
    if (data) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        var ref7, ref8, ref9, ref10, ref11, ref12, ref13;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (not_available_nft_module_default())["not-available-nft"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    children: (ref7 = data === null || data === void 0 ? void 0 : (ref = data.notAvailableMessage) === null || ref === void 0 ? void 0 : ref.content) !== null && ref7 !== void 0 ? ref7 : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (not_available_nft_module_default())["lower-wrapper"],
                    children: [
                        !jwt ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (not_available_nft_module_default())["not-available-box"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                    variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING5 */.H.HEADING5,
                                    className: (not_available_nft_module_default())["not-available-headline"],
                                    element: "span",
                                    children: (ref8 = data === null || data === void 0 ? void 0 : (ref1 = data.onLoginHeadline) === null || ref1 === void 0 ? void 0 : ref1.headlineContent) !== null && ref8 !== void 0 ? ref8 : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                    variant: typeography_variants_enum/* TypographyVariantsEnum.BODY */.H.BODY,
                                    element: "span",
                                    children: (ref9 = data === null || data === void 0 ? void 0 : (ref2 = data.onLoginDescription) === null || ref2 === void 0 ? void 0 : ref2.content) !== null && ref9 !== void 0 ? ref9 : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                    className: (not_available_nft_module_default())["first-button"],
                                    onClick: function() {
                                        return router.push(route_path_enum/* RoutePath.LOGIN */.h3.LOGIN);
                                    },
                                    children: (ref10 = data === null || data === void 0 ? void 0 : (ref3 = data.loginButton) === null || ref3 === void 0 ? void 0 : ref3.buttonText) !== null && ref10 !== void 0 ? ref10 : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                    className: (not_available_nft_module_default())["last-button"],
                                    onClick: function() {
                                        return router.push(route_path_enum/* RoutePath.REGISTER */.h3.REGISTER);
                                    },
                                    variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                                    children: (ref11 = data === null || data === void 0 ? void 0 : (ref4 = data.registerButton) === null || ref4 === void 0 ? void 0 : ref4.buttonText) !== null && ref11 !== void 0 ? ref11 : ""
                                })
                            ]
                        }) : undefined,
                        !walletId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (not_available_nft_module_default())["not-available-box"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                    variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING5 */.H.HEADING5,
                                    className: (not_available_nft_module_default())["not-available-headline"],
                                    element: "span",
                                    children: (ref12 = data === null || data === void 0 ? void 0 : (ref5 = data.onConnectWithWalletHeadline) === null || ref5 === void 0 ? void 0 : ref5.headlineContent) !== null && ref12 !== void 0 ? ref12 : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                    variant: typeography_variants_enum/* TypographyVariantsEnum.BODY */.H.BODY,
                                    element: "span",
                                    children: (ref13 = data === null || data === void 0 ? void 0 : (ref6 = data.onWalletConnectDescription) === null || ref6 === void 0 ? void 0 : ref6.content) !== null && ref13 !== void 0 ? ref13 : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(wallet_connect_button/* default */.Z, {
                                    className: (not_available_nft_module_default())["first-button"]
                                })
                            ]
                        }) : undefined
                    ]
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
/* harmony default export */ var not_available_nft = (NotAvailableNft);

// EXTERNAL MODULE: ./src/components/_shared/sales-box/owner-options/owner-options.module.scss
var owner_options_module = __webpack_require__(96238);
var owner_options_module_default = /*#__PURE__*/__webpack_require__.n(owner_options_module);
;// CONCATENATED MODULE: ./src/components/_shared/sales-box/owner-options/owner-options.tsx













var OwnerOptions = function() {
    var data = useInstanceDetailPage();
    var router = (0,client_router.useRouter)();
    var ref = (0,react.useState)(false), showDialog = ref[0], setShowDialog = ref[1];
    var variant = (0,useFullVariantByIdSsr_hook/* useFullVariantByIdSsr */.Q)();
    if (data) {
        var ref1, ref2, ref3, ref4, ref5, ref6;
        var ref7, ref8, ref9, ref10, ref11;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (owner_options_module_default())["owner-options"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    children: (ref7 = data === null || data === void 0 ? void 0 : (ref1 = data.ownerOptionDescription) === null || ref1 === void 0 ? void 0 : ref1.content) !== null && ref7 !== void 0 ? ref7 : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (owner_options_module_default())["owner-options-wallet-connect"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(wallet_connect_button/* default */.Z, {
                        buttonText: data === null || data === void 0 ? void 0 : (ref2 = data.retrieveUnlockables) === null || ref2 === void 0 ? void 0 : ref2.buttonText,
                        variantId: variant.id
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING5 */.H.HEADING5,
                    className: (owner_options_module_default())["not-available-headline"],
                    element: "span",
                    children: (ref8 = data === null || data === void 0 ? void 0 : (ref3 = data.onLoginHeadline) === null || ref3 === void 0 ? void 0 : ref3.headlineContent) !== null && ref8 !== void 0 ? ref8 : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    variant: typeography_variants_enum/* TypographyVariantsEnum.BODY */.H.BODY,
                    element: "span",
                    children: (ref9 = data === null || data === void 0 ? void 0 : (ref4 = data.onLoginDescription) === null || ref4 === void 0 ? void 0 : ref4.content) !== null && ref9 !== void 0 ? ref9 : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (owner_options_module_default())["owner-options-lower-wrapper"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                            onClick: function() {
                                return setShowDialog(true);
                            },
                            children: (ref10 = data === null || data === void 0 ? void 0 : (ref5 = data.loginButton) === null || ref5 === void 0 ? void 0 : ref5.buttonText) !== null && ref10 !== void 0 ? ref10 : ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                            onClick: function() {
                                return router.push(route_path_enum/* RoutePath.REGISTER */.h3.REGISTER);
                            },
                            variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                            children: (ref11 = data === null || data === void 0 ? void 0 : (ref6 = data.registerButton) === null || ref6 === void 0 ? void 0 : ref6.buttonText) !== null && ref11 !== void 0 ? ref11 : ""
                        })
                    ]
                }),
                showDialog ? /*#__PURE__*/ (0,jsx_runtime.jsx)(login_dialog/* default */.Z, {
                    onClose: function() {
                        return setShowDialog(false);
                    }
                }) : undefined
            ]
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
/* harmony default export */ var owner_options = (OwnerOptions);

// EXTERNAL MODULE: ./src/components/_shared/sales-box/sales-box.module.scss
var sales_box_module = __webpack_require__(78839);
var sales_box_module_default = /*#__PURE__*/__webpack_require__.n(sales_box_module);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 2 modules
var lib_esm = __webpack_require__(35553);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var bytes_lib_esm = __webpack_require__(16441);
// EXTERNAL MODULE: ./node_modules/@ethersproject/keccak256/lib.esm/index.js
var keccak256_lib_esm = __webpack_require__(38197);
// EXTERNAL MODULE: ./node_modules/@ethersproject/strings/lib.esm/utf8.js + 1 modules
var utf8 = __webpack_require__(29251);
// EXTERNAL MODULE: ./node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__(1581);
;// CONCATENATED MODULE: ./node_modules/@ethersproject/solidity/lib.esm/_version.js
const version = "solidity/5.6.1";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ./node_modules/@ethersproject/solidity/lib.esm/index.js






const regexBytes = new RegExp("^bytes([0-9]+)$");
const regexNumber = new RegExp("^(u?int)([0-9]*)$");
const regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
const Zeros = "0000000000000000000000000000000000000000000000000000000000000000";


const logger = new logger_lib_esm/* Logger */.Yd(version);
function _pack(type, value, isArray) {
    switch (type) {
        case "address":
            if (isArray) {
                return (0,bytes_lib_esm/* zeroPad */.Bu)(value, 32);
            }
            return (0,bytes_lib_esm/* arrayify */.lE)(value);
        case "string":
            return (0,utf8/* toUtf8Bytes */.Y0)(value);
        case "bytes":
            return (0,bytes_lib_esm/* arrayify */.lE)(value);
        case "bool":
            value = (value ? "0x01" : "0x00");
            if (isArray) {
                return (0,bytes_lib_esm/* zeroPad */.Bu)(value, 32);
            }
            return (0,bytes_lib_esm/* arrayify */.lE)(value);
    }
    let match = type.match(regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        let size = parseInt(match[2] || "256");
        if ((match[2] && String(size) !== match[2]) || (size % 8 !== 0) || size === 0 || size > 256) {
            logger.throwArgumentError("invalid number type", "type", type);
        }
        if (isArray) {
            size = 256;
        }
        value = bignumber/* BigNumber.from */.O$.from(value).toTwos(size);
        return (0,bytes_lib_esm/* zeroPad */.Bu)(value, size / 8);
    }
    match = type.match(regexBytes);
    if (match) {
        const size = parseInt(match[1]);
        if (String(size) !== match[1] || size === 0 || size > 32) {
            logger.throwArgumentError("invalid bytes type", "type", type);
        }
        if ((0,bytes_lib_esm/* arrayify */.lE)(value).byteLength !== size) {
            logger.throwArgumentError(`invalid value for ${type}`, "value", value);
        }
        if (isArray) {
            return (0,bytes_lib_esm/* arrayify */.lE)((value + Zeros).substring(0, 66));
        }
        return value;
    }
    match = type.match(regexArray);
    if (match && Array.isArray(value)) {
        const baseType = match[1];
        const count = parseInt(match[2] || String(value.length));
        if (count != value.length) {
            logger.throwArgumentError(`invalid array length for ${type}`, "value", value);
        }
        const result = [];
        value.forEach(function (value) {
            result.push(_pack(baseType, value, true));
        });
        return (0,bytes_lib_esm/* concat */.zo)(result);
    }
    return logger.throwArgumentError("invalid type", "type", type);
}
// @TODO: Array Enum
function pack(types, values) {
    if (types.length != values.length) {
        logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    }
    const tight = [];
    types.forEach(function (type, index) {
        tight.push(_pack(type, values[index]));
    });
    return (0,bytes_lib_esm/* hexlify */.Dv)((0,bytes_lib_esm/* concat */.zo)(tight));
}
function keccak256(types, values) {
    return (0,keccak256_lib_esm/* keccak256 */.w)(pack(types, values));
}
function sha256(types, values) {
    return hashSha256(pack(types, values));
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./src/utils/_helper/hash-generator.ts
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var HashGenerator = /*#__PURE__*/ function() {
    "use strict";
    function HashGenerator() {
        _classCallCheck(this, HashGenerator);
    }
    HashGenerator.createResaleFixPriceHash = function createResaleFixPriceHash(tokenContractAddress, tokenId, tradeId, priceInEth) {
        var priceInWei = lib_esm/* parseEther */.fi(priceInEth.toString());
        return keccak256([
            "address",
            "uint",
            "string",
            "uint"
        ], [
            tokenContractAddress,
            tokenId,
            tradeId,
            priceInWei
        ]);
    };
    return HashGenerator;
}();

// EXTERNAL MODULE: ./src/utils/_helper/sign-helper.ts
var sign_helper = __webpack_require__(21879);
// EXTERNAL MODULE: ./src/components/_shared/checkbox/checkbox.tsx
var checkbox_checkbox = __webpack_require__(25977);
// EXTERNAL MODULE: ./src/components/_shared/input-fields/input/input.tsx
var input = __webpack_require__(17850);
// EXTERNAL MODULE: ./src/components/_shared/sales-box/sell-ntf-box/sell-nft-box.module.scss
var sell_nft_box_module = __webpack_require__(824);
var sell_nft_box_module_default = /*#__PURE__*/__webpack_require__.n(sell_nft_box_module);
;// CONCATENATED MODULE: ./src/components/_shared/sales-box/sell-ntf-box/sell-nft-box.tsx
function sell_nft_box_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function sell_nft_box_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                sell_nft_box_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                sell_nft_box_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}























var SellNftBox = function() {
    var ref18, ref1;
    var data = useInstanceDetailPage();
    var ref2 = (0,hooks/* useAppSelector */.C)(function(state) {
        return {
            instance: state.productSlice.instance,
            walletId: state.blockchainSlice.walletId,
            ethereumPriceData: state.blockchainSlice.ethereumPriceData,
            sellInstanceFixPriceModel: state.resaleSlice.sellInstanceFixPriceModel
        };
    }), instance = ref2.instance, walletId = ref2.walletId, ethereumPriceData = ref2.ethereumPriceData, sellInstanceFixPriceModel = ref2.sellInstanceFixPriceModel;
    var ref3 = (0,react.useState)(false), onConfirm = ref3[0], setOnConfirm = ref3[1];
    var ref4 = (0,react.useState)(0), exchangeCount = ref4[0], setExchangeCount = ref4[1];
    var ref5 = (0,react.useState)(false), isMetaMaskOpen = ref5[0], setIsMetaMaskOpen = ref5[1];
    var schema = yup_es/* object */.Ry({
        startDate: yup_es/* string */.Z_().required((ref18 = data === null || data === void 0 ? void 0 : data.startDate.fieldErrorMessages) === null || ref18 === void 0 ? void 0 : ref18.required),
        price: yup_es/* string */.Z_().required((ref1 = data === null || data === void 0 ? void 0 : data.ethPrice.fieldErrorMessages) === null || ref1 === void 0 ? void 0 : ref1.required)
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref6 = (0,dist_index_esm/* useForm */.cI)({
        mode: "onSubmit",
        resolver: (0,yup_module/* yupResolver */.X)(schema)
    }), register = ref6.register, getValues = ref6.getValues, handleSubmit = ref6.handleSubmit, watch = ref6.watch, errors = ref6.formState.errors;
    var watchCheckboxFields = watch([
        "conditionsConfirmed",
        "agbConfirmed"
    ]);
    var watchPrice = watch("price");
    (0,react.useEffect)(function() {
        if (ethereumPriceData) {
            setExchangeCount((watchPrice === null || watchPrice === void 0 ? void 0 : watchPrice.replace(/,/g, ".")) / ethereumPriceData.exchangeRate);
        }
    }, [
        watchPrice
    ]);
    (0,react.useEffect)(function() {
        if (sellInstanceFixPriceModel.status && sellInstanceFixPriceModel.status !== 200) {
            dispatch((0,resale_slice/* removeSellInstanceFixPriceStatus */.U1)());
        }
    }, [
        sellInstanceFixPriceModel.status
    ]);
    var submitForm = function() {
        setOnConfirm(true);
    };
    var sellNft = function() {
        var _ref = sell_nft_box_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref15, ref16, tradeId, ethPrice, ref17, hash, signRes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!instance) {
                            _ctx.next = 20;
                            break;
                        }
                        ;
                        tradeId = (0,v4/* default */.Z)();
                        ethPrice = Number(getValues("price").replace(/,/g, "."));
                        ;
                        hash = HashGenerator.createResaleFixPriceHash((ref17 = (ref = instance.variant) === null || ref === void 0 ? void 0 : (ref15 = ref.salesAttribute) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.contract) === null || ref16 === void 0 ? void 0 : ref16.contractAddress) !== null && ref17 !== void 0 ? ref17 : "", instance.id, tradeId, ethPrice);
                        if (!hash) {
                            _ctx.next = 20;
                            break;
                        }
                        setIsMetaMaskOpen(true);
                        _ctx.prev = 8;
                        _ctx.next = 11;
                        return (0,sign_helper/* signHash */.V)(hash);
                    case 11:
                        signRes = _ctx.sent;
                        dispatch((0,resale_slice/* sellInstanceFixPrice */.VT)({
                            instanceId: instance.id,
                            data: {
                                price: ethPrice,
                                signature: signRes,
                                tradeID: tradeId,
                                startDate: (0,time_helper/* dateToISOString */.CI)(getValues("startDate"))
                            }
                        }));
                        setIsMetaMaskOpen(false);
                        _ctx.next = 20;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](8);
                        setIsMetaMaskOpen(false);
                        return _ctx.abrupt("return");
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    16
                ]
            ]);
        }));
        return function sellNft() {
            return _ref.apply(this, arguments);
        };
    }();
    if (data && instance) {
        var ref7, ref8, ref9, ref10, ref11, ref12, ref13;
        var ref14, _fieldTooltip;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: walletId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: walletId === instance.ownerWallet ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: onConfirm ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((sell_nft_box_module_default())["sell-nft-box"], " ").concat((sell_nft_box_module_default())["confirmation-box"]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                                name: "conditionsConfirmed",
                                register: register,
                                children: "".concat(data.confirmListingPart1, " ").concat((ref14 = (ref7 = instance.variant) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.salesAttribute) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.contract) === null || ref9 === void 0 ? void 0 : ref9.contractAddress) !== null && ref14 !== void 0 ? ref14 : "", " ").concat(data.confirmListingPart2, " ").concat(instance === null || instance === void 0 ? void 0 : instance.id, "\n                                 ").concat(data.confirmListingPart3, " ").concat(getValues("price"), "\u039E ").concat(data.confirmListingPart4)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox/* Checkbox */.X, {
                                name: "agbConfirmed",
                                register: register,
                                children: (_fieldTooltip = data.confirmAgb.fieldTooltip) !== null && _fieldTooltip !== void 0 ? _fieldTooltip : ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (sell_nft_box_module_default())["sell-actions"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                        disabled: isMetaMaskOpen || sellInstanceFixPriceModel.pending,
                                        onClick: function() {
                                            return setOnConfirm(false);
                                        },
                                        className: (sell_nft_box_module_default())["abort-sale-button"],
                                        variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                                        children: data.backButton.buttonText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                        disabled: !watchCheckboxFields[0] || !watchCheckboxFields[1],
                                        pending: sellInstanceFixPriceModel.pending || isMetaMaskOpen,
                                        className: (sell_nft_box_module_default())["confirm-sale-button"],
                                        onClick: sellNft,
                                        children: data.sellButton.buttonText
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: handleSubmit(submitForm),
                        className: (sell_nft_box_module_default())["sell-nft-box"],
                        children: [
                            instance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                children: instance.creatoken ? data === null || data === void 0 ? void 0 : (ref10 = data.cannotSellCreatoken) === null || ref10 === void 0 ? void 0 : ref10.content : data === null || data === void 0 ? void 0 : (ref11 = data.sellNftDescription) === null || ref11 === void 0 ? void 0 : ref11.content
                            }) : undefined,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (sell_nft_box_module_default())["sell-nft-box-left-wrapper"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                                                register: register,
                                                placeholder: data.startDate.fieldLabel,
                                                disabled: instance === null || instance === void 0 ? void 0 : instance.creatoken,
                                                title: data.startDate.fieldLabel,
                                                errorMessage: errors === null || errors === void 0 ? void 0 : (ref12 = errors["startDate"]) === null || ref12 === void 0 ? void 0 : ref12.message,
                                                name: "startDate",
                                                type: "datetime-local"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                                                register: register,
                                                placeholder: data.ethPrice.fieldLabel,
                                                disabled: instance === null || instance === void 0 ? void 0 : instance.creatoken,
                                                errorMessage: errors === null || errors === void 0 ? void 0 : (ref13 = errors["price"]) === null || ref13 === void 0 ? void 0 : ref13.message,
                                                title: data.ethPrice.fieldLabel,
                                                className: (sell_nft_box_module_default())["lower-input"],
                                                name: "price"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (sell_nft_box_module_default())["exchange-rate"],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                    variant: typeography_variants_enum/* TypographyVariantsEnum.CAPTION */.H.CAPTION,
                                                    children: exchangeCount > 0 ? "(~".concat((0,locale_helper/* getLocalePrice */.yb)(exchangeCount), "\u20AC)") : ""
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (sell_nft_box_module_default())["sell-nft-box-right-wrapper"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                            disabled: instance === null || instance === void 0 ? void 0 : instance.creatoken,
                                            className: (sell_nft_box_module_default())["confirm-sale-button"],
                                            children: data.sellButton.buttonText
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (sell_nft_box_module_default())["connect-wallet-wrapper"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: typeography_variants_enum/* TypographyVariantsEnum.BODY_SMALL */.H.BODY_SMALL,
                        children: data.correctAccountWrongWalletPrompt.content
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (sell_nft_box_module_default())["connect-wallet-wrapper"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: typeography_variants_enum/* TypographyVariantsEnum.BODY_SMALL */.H.BODY_SMALL,
                        children: data.sellNftDescription.content
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sales_box_connect_wallet, {})
                ]
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
/* harmony default export */ var sell_nft_box = (SellNftBox);

;// CONCATENATED MODULE: ./src/components/_shared/sales-box/sales-box.tsx





















var SalesBox = function(props) {
    var ref6, ref1, ref2;
    var data = useInstanceDetailPage();
    var globalData = (0,useGlobal_hook/* useGlobal */.O)();
    var ref3 = (0,hooks/* useAppSelector */.C)(function(state) {
        return {
            jwt: state.authentification.jwt,
            instanceInBasket: state.checkoutSlice.basket,
            user: state.userSlice.user,
            isGeoblocked: state.userSlice.isGeoblocked,
            walletId: state.blockchainSlice.walletId,
            addToBasketStatus: state.checkoutSlice.addToBasketStatus,
            pending: state.checkoutSlice.pending,
            instance: state.productSlice.instance
        };
    }), jwt = ref3.jwt, isGeoblocked = ref3.isGeoblocked, user = ref3.user, walletId = ref3.walletId, pending = ref3.pending, addToBasketStatus = ref3.addToBasketStatus, instance1 = ref3.instance;
    var ref4 = (0,react.useState)(undefined), instanceIdToBuy = ref4[0], setInstanceIdToBuy = ref4[1];
    var variant = (0,useFullVariantByIdSsr_hook/* useFullVariantByIdSsr */.Q)();
    var isOwn = function() {
        return !!instance1 && (!!user && user.id === instance1.ownerId || walletId === instance1.ownerWallet);
    };
    var renderHeadline = function() {
        if (data && instance1) {
            var ref, ref5;
            if (!jwt && instance1.status === instance_status/* InstanceStatus.OPEN */.O.OPEN && props.salesType === sales_type/* SalesType.FIXED_PRICE */.r.FIXED_PRICE && !(0,time_helper/* isDateInPast */.OF)(variant === null || variant === void 0 ? void 0 : (ref = variant.salesAttribute) === null || ref === void 0 ? void 0 : ref.saleTo)) {
                return data.fixedPriceHeadline.headlineContent;
            } else if (!jwt && !isOwn() || !isOwn() && instance1.status !== instance_status/* InstanceStatus.OPEN */.O.OPEN || !instance1.ownerId && !instance1.ownerWallet && (0,time_helper/* isDateInPast */.OF)(variant === null || variant === void 0 ? void 0 : (ref5 = variant.salesAttribute) === null || ref5 === void 0 ? void 0 : ref5.saleTo)) {
                return data.notAvailableHeadline.headlineContent;
            } else if (!isOwn() && props.salesType === sales_type/* SalesType.FIXED_PRICE */.r.FIXED_PRICE && instance1.status === instance_status/* InstanceStatus.OPEN */.O.OPEN) {
                return data.fixedPriceHeadline.headlineContent;
            } else if (isOwn() && instance1.minted && jwt && instance1.status === instance_status/* InstanceStatus.SOLD */.O.SOLD) {
                return data.resaleHeadline.headlineContent;
            } else if (jwt && instance1.minted && instance1.status !== instance_status/* InstanceStatus.SOLD */.O.SOLD) {
                return data.abortResaleHeadline.headlineContent;
            } else if (isOwn() && !instance1.minted) {
                return data.mintingHeadline.headlineContent;
            } else if (!jwt && isOwn()) {
                return data.ownerOptionsHeadline.headlineContent;
            }
        } else {
            return "";
        }
    };
    var renderSalesBox = function(instance) {
        var ref;
        if ((instance.status !== instance_status/* InstanceStatus.OPEN */.O.OPEN || !instance.ownerId && !instance.ownerWallet && (0,time_helper/* isDateInPast */.OF)(variant === null || variant === void 0 ? void 0 : (ref = variant.salesAttribute) === null || ref === void 0 ? void 0 : ref.saleTo)) && !isOwn()) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(not_available_nft, {});
        } else if (instance.status === instance_status/* InstanceStatus.OPEN */.O.OPEN && !isOwn()) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(fixed_price_sale, {
                isInitial: !instance.ownerId && !instance.ownerWallet,
                instance: instance,
                variant: variant,
                pending: pending || addToBasketStatus === response_codes_enum/* ResponseCodes.OK */.Y.OK,
                isGeoblocked: isGeoblocked,
                onBuy: function() {
                    return setInstanceIdToBuy(instance.id);
                }
            });
        } else if (!jwt && isOwn()) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(owner_options, {});
        } else if (isOwn() && !instance.minted) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(minting_box, {});
        } else if (isOwn() && jwt && instance.minted && instance.status === instance_status/* InstanceStatus.SOLD */.O.SOLD) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(sell_nft_box, {});
        } else if (isOwn() && jwt && instance.minted && instance.status === instance_status/* InstanceStatus.OPEN */.O.OPEN) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(cancel_resale_box, {
                instance: instance,
                variant: variant
            });
        } else {
            return undefined;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (sales_box_module_default()).anchor,
                id: "salesbox"
            }),
            data && instance1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (sales_box_module_default())["sales-box"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (sales_box_module_default()).header,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (sales_box_module_default())["sales-title"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (sales_box_module_default())["sales-title-inner"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING4_BOLD */.H.HEADING4_BOLD,
                                        children: renderHeadline()
                                    })
                                })
                            }),
                            instance1.status === instance_status/* InstanceStatus.OPEN */.O.OPEN && !isOwn() && (0,time_helper/* isDateInFuture */.ek)(variant === null || variant === void 0 ? void 0 : (ref6 = variant.salesAttribute) === null || ref6 === void 0 ? void 0 : ref6.saleTo) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                variant: typeography_variants_enum/* TypographyVariantsEnum.BODY */.H.BODY,
                                className: (sales_box_module_default())["price-info-box"],
                                children: !instance1.ownerId ? data.buyWithEthOrFiat.content : data.buyWithEth.content
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (sales_box_module_default())["main-content"],
                        children: renderSalesBox(instance1)
                    }),
                    instance1.status === instance_status/* InstanceStatus.OPEN */.O.OPEN && props.salesType === sales_type/* SalesType.FIXED_PRICE */.r.FIXED_PRICE && !isOwn() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(sales_box_footer/* default */.Z, {
                        headline: globalData === null || globalData === void 0 ? void 0 : (ref1 = globalData.salesBox) === null || ref1 === void 0 ? void 0 : ref1.feesHeadline,
                        description: globalData === null || globalData === void 0 ? void 0 : (ref2 = globalData.salesBox) === null || ref2 === void 0 ? void 0 : ref2.feesDescription
                    }) : undefined,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(login_dialog/* default */.Z, {
                        withBuyOption: {
                            setIdToBuy: function(instanceId) {
                                return setInstanceIdToBuy(instanceId);
                            },
                            idToBuy: instanceIdToBuy,
                            salesType: sales_type/* SalesType.FIXED_PRICE */.r.FIXED_PRICE
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
        ]
    });
};
/* harmony default export */ var sales_box = (SalesBox);

// EXTERNAL MODULE: ./src/components/_shared/spacer/spacer.tsx
var spacer = __webpack_require__(4363);
// EXTERNAL MODULE: ./src/redux/index.tsx + 21 modules
var redux = __webpack_require__(37287);
// EXTERNAL MODULE: ./src/utils/_enums/basic-card-variants.enum.ts
var basic_card_variants_enum = __webpack_require__(90017);
// EXTERNAL MODULE: ./src/utils/_enums/filter-expression.enum.tsx
var filter_expression_enum = __webpack_require__(55190);
// EXTERNAL MODULE: ./src/components/_shared/teaser/teaser.tsx + 1 modules
var teaser = __webpack_require__(10725);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card/teaser-card.tsx + 17 modules
var teaser_card = __webpack_require__(33076);
;// CONCATENATED MODULE: ./src/components/instance-detail/instance-detail-more-instances-box/more-instances-box.tsx












var MoreInstancesBox = function() {
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,client_router.useRouter)();
    var data1 = useInstanceDetailPage();
    var variant = (0,useFullVariantByIdSsr_hook/* useFullVariantByIdSsr */.Q)();
    var ref1 = (0,hooks/* useAppSelector */.C)(function(state) {
        return {
            instances: state.productSlice.moreInstances,
            addToBasketStatus: state.checkoutSlice.addToBasketStatus,
            addToBasketPending: state.checkoutSlice.pending
        };
    }), instances = ref1.instances, addToBasketStatus = ref1.addToBasketStatus, addToBasketPending = ref1.addToBasketPending;
    (0,react.useEffect)(function() {
        fetchInstancesWithFilter(0, 6);
    }, [
        variant,
        router.query.instanceId
    ]);
    var fetchInstancesWithFilter = function(offset, pageSize) {
        if (variant === null || variant === void 0 ? void 0 : variant.id) {
            dispatch((0,redux/* fetchMoreInstances */.BZ)([
                {
                    value: pageSize.toString(),
                    param: "size",
                    comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
                },
                {
                    value: offset.toString(),
                    param: "offset",
                    comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
                },
                {
                    value: variant.id.toString(),
                    param: "variantId",
                    comparisonType: filter_expression_enum/* FilterExpression.equals */.p.equals
                },
                {
                    value: "OPEN",
                    param: "status",
                    comparisonType: filter_expression_enum/* FilterExpression.equals */.p.equals
                },
                {
                    value: router.query.instanceId,
                    param: "id",
                    comparisonType: filter_expression_enum/* FilterExpression.notEquals */.p.notEquals
                },
                {
                    param: "sort",
                    comparisonType: filter_expression_enum/* FilterExpression.none */.p.none,
                    value: "serialNumber,asc"
                }
            ]));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser/* default */.Z, {
            headline: data1.moreInstancesListHeadline.headlineContent,
            maxCards: instances === null || instances === void 0 ? void 0 : instances.maxNumber,
            resetOnChange: Number(router.query.instanceId),
            headlineElement: "h2",
            pending: instances.pending,
            cards: instances === null || instances === void 0 ? void 0 : (ref = instances.data) === null || ref === void 0 ? void 0 : ref.map(function(instance) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card/* default */.Z, {
                    instance: instance
                }, "more-instances-instance-".concat(instance.id));
            }),
            onLoadNewItems: function(data) {
                fetchInstancesWithFilter(data.pageOrOffset, data.size);
            },
            type: basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_SMALL */.I.BASIC_CARD_SMALL
        })
    });
};
/* harmony default export */ var more_instances_box = (MoreInstancesBox);

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./src/api/hooks/useCurrentLanguage.hook.ts + 1 modules
var useCurrentLanguage_hook = __webpack_require__(91785);
// EXTERNAL MODULE: ./src/api/hooks/useKeywords.hook.tsx
var useKeywords_hook = __webpack_require__(10010);
// EXTERNAL MODULE: ./src/api/hooks/useLookupTableData.hook.ts
var useLookupTableData_hook = __webpack_require__(12310);
// EXTERNAL MODULE: ./src/api/hooks/useTypoContent.hook.ts
var useTypoContent_hook = __webpack_require__(80612);
// EXTERNAL MODULE: ./src/api/services/typo.service.tsx + 53 modules
var typo_service = __webpack_require__(55584);
// EXTERNAL MODULE: ./src/assets/creatoki.png
var creatoki = __webpack_require__(13692);
;// CONCATENATED MODULE: ./src/utils/_enums/aspect-ratio.enum.ts
var AspectRatio;
(function(AspectRatio) {
    AspectRatio["WIDESCREEN"] = "widescreen";
    AspectRatio["FULLSCREEN"] = "fullscreen";
})(AspectRatio || (AspectRatio = {}));

// EXTERNAL MODULE: ./src/utils/_enums/image-content-type.enum.tsx
var image_content_type_enum = __webpack_require__(26884);
// EXTERNAL MODULE: ./src/utils/_helper/creatoken-posterUrl-resolver.ts
var creatoken_posterUrl_resolver = __webpack_require__(70808);
// EXTERNAL MODULE: ./src/utils/_helper/generate-url-to-user-oan.tsx
var generate_url_to_user_oan = __webpack_require__(19239);
// EXTERNAL MODULE: ./src/utils/_helper/truncate-string-helper.ts
var truncate_string_helper = __webpack_require__(18841);
// EXTERNAL MODULE: ./src/utils/_hooks/useFilterAttachments.hook.ts
var useFilterAttachments_hook = __webpack_require__(67674);
// EXTERNAL MODULE: ./src/components/_shared/carousel/carousel.tsx
var carousel = __webpack_require__(64350);
// EXTERNAL MODULE: ./src/components/_shared/media/media.tsx + 3 modules
var media = __webpack_require__(38925);
// EXTERNAL MODULE: ./src/components/_shared/stage/stage-image-button-token/stage-image-button-token.tsx
var stage_image_button_token = __webpack_require__(58523);
// EXTERNAL MODULE: ./src/components/_shared/stage-image-background/stage-image-background.tsx + 1 modules
var stage_image_background = __webpack_require__(93659);
// EXTERNAL MODULE: ./src/components/_shared/tool-tip/tool-tip.tsx
var tool_tip = __webpack_require__(62486);
// EXTERNAL MODULE: ./src/components/instance-detail/instance-detail-stage/instance-detail-stage.module.scss
var instance_detail_stage_module = __webpack_require__(2236);
var instance_detail_stage_module_default = /*#__PURE__*/__webpack_require__.n(instance_detail_stage_module);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./src/utils/_hooks/useBreakpoints.hook.ts
var useBreakpoints_hook = __webpack_require__(93890);
// EXTERNAL MODULE: ./src/components/variant-detail/variant-detail-stage/variant-detail-stage-meta-box/variant-detail-stage-meta-box-audio-video/variant-detail-stage-meta-box-audio-video.tsx
var variant_detail_stage_meta_box_audio_video = __webpack_require__(78300);
// EXTERNAL MODULE: ./src/components/variant-detail/variant-detail-stage/variant-detail-stage-meta-box/variant-detail-stage-meta-box-keywords/variant-detail-stage-meta-box-keywords.tsx
var variant_detail_stage_meta_box_keywords = __webpack_require__(38456);
// EXTERNAL MODULE: ./src/components/instance-detail/instance-detail-stage/instance-detail-stage-meta-box/instance-detail-stage-meta-box.module.scss
var instance_detail_stage_meta_box_module = __webpack_require__(21058);
var instance_detail_stage_meta_box_module_default = /*#__PURE__*/__webpack_require__.n(instance_detail_stage_meta_box_module);
;// CONCATENATED MODULE: ./src/components/instance-detail/instance-detail-stage/instance-detail-stage-meta-box/instance-detail-stage-meta-box.tsx


















var InstanceDetailStageMetaBox = function(param) {
    var title = param.title, author = param.author, publisher = param.publisher, release = param.release, copies = param.copies, genre = param.genre, keywords = param.keywords, ownerWallet = param.ownerWallet, ownerUsername = param.ownerUsername, onButtonClick = param.onButtonClick;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), openModal = ref3[0], setModal = ref3[1];
    var data = useInstanceDetailPage();
    var breakpoint = (0,useBreakpoints_hook/* default */.Z)();
    var variant = (0,useFullVariantByIdSsr_hook/* useFullVariantByIdSsr */.Q)();
    var samples = (0,useFilterAttachments_hook/* default */.Z)(variant_image_type/* VariantImageType.PRODUCT_SAMPLE */.W.PRODUCT_SAMPLE, variant === null || variant === void 0 ? void 0 : variant.attachments);
    var instance = (0,hooks/* useAppSelector */.C)(function(state) {
        return {
            instance: state.productSlice.instance
        };
    }).instance;
    var ref4, ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (instance_detail_stage_meta_box_module_default())["variant-detail-stage-meta-box"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (instance_detail_stage_meta_box_module_default())["variant-detail-stage-meta-box-infos"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (instance_detail_stage_meta_box_module_default())["variant-detail-stage-meta-box__keywords"],
                                children: [
                                    genre && /*#__PURE__*/ (0,jsx_runtime.jsx)(variant_detail_stage_meta_box_keywords/* VariantDetailStageMetaBoxKeywords */.y, {
                                        children: genre
                                    }, genre),
                                    breakpoint === "mobile" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(variant_detail_stage_meta_box_keywords/* VariantDetailStageMetaBoxKeywords */.y, {
                                        variant: "keyword",
                                        children: keywords === null || keywords === void 0 ? void 0 : keywords[0]
                                    }, keywords === null || keywords === void 0 ? void 0 : keywords[0]) : keywords === null || keywords === void 0 ? void 0 : keywords.map(function(keyword) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(variant_detail_stage_meta_box_keywords/* VariantDetailStageMetaBoxKeywords */.y, {
                                            variant: "keyword",
                                            children: keyword
                                        }, keyword);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                className: (instance_detail_stage_meta_box_module_default())["instance-title"],
                                variant: breakpoint === "mobile" ? typeography_variants_enum/* TypographyVariantsEnum.HEADING3_BOLD */.H.HEADING3_BOLD : typeography_variants_enum/* TypographyVariantsEnum.VARIANT_HEADING */.H.VARIANT_HEADING,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (instance_detail_stage_meta_box_module_default())["variant-detail-stage-meta-box-body-container"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                    className: (instance_detail_stage_meta_box_module_default()).table,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* Typography */.Z, {
                                                            variant: typeography_variants_enum/* TypographyVariantsEnum.TABLE_TITLE */.H.TABLE_TITLE,
                                                            children: [
                                                                data === null || data === void 0 ? void 0 : data.stageMetaBoxTitleAuthor,
                                                                ":"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                            variant: typeography_variants_enum/* TypographyVariantsEnum.TABLE_VALUE */.H.TABLE_VALUE,
                                                            children: author
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* Typography */.Z, {
                                                            variant: typeography_variants_enum/* TypographyVariantsEnum.TABLE_TITLE */.H.TABLE_TITLE,
                                                            children: [
                                                                data === null || data === void 0 ? void 0 : data.stageMetaBoxTitlePublisher,
                                                                ":"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                            variant: typeography_variants_enum/* TypographyVariantsEnum.TABLE_VALUE */.H.TABLE_VALUE,
                                                            children: publisher
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* Typography */.Z, {
                                                            variant: typeography_variants_enum/* TypographyVariantsEnum.TABLE_TITLE */.H.TABLE_TITLE,
                                                            children: [
                                                                data === null || data === void 0 ? void 0 : data.stageMetaBoxTitleRelease,
                                                                ":"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                            variant: typeography_variants_enum/* TypographyVariantsEnum.TABLE_VALUE */.H.TABLE_VALUE,
                                                            children: (0,time_helper/* formatDate */.p6)(release)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography/* Typography */.Z, {
                                                            variant: typeography_variants_enum/* TypographyVariantsEnum.TABLE_TITLE */.H.TABLE_TITLE,
                                                            children: [
                                                                data === null || data === void 0 ? void 0 : data.stageMetaBoxTitleCopies,
                                                                ":"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                            variant: typeography_variants_enum/* TypographyVariantsEnum.TABLE_VALUE */.H.TABLE_VALUE,
                                                            children: copies
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (instance_detail_stage_meta_box_module_default())["button-box"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                    onClick: function() {
                                        return setModal(true);
                                    },
                                    icon: {
                                        element: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: [
                                                "fas",
                                                "play"
                                            ]
                                        }),
                                        align: "left"
                                    },
                                    variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED_FILLED_ICON */.l.SECONDARY_OUTLINED_FILLED_ICON,
                                    className: (instance_detail_stage_meta_box_module_default())["listen-button"],
                                    children: data === null || data === void 0 ? void 0 : data.stageFileDescription
                                }),
                                (instance === null || instance === void 0 ? void 0 : instance.status) !== instance_status/* InstanceStatus.SOLD */.O.SOLD ? /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                    onClick: onButtonClick,
                                    icon: {
                                        element: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: [
                                                "far",
                                                "chevron-down"
                                            ]
                                        }),
                                        align: "right"
                                    },
                                    variant: button_variants_enum/* ButtonVariantsEnum.PRIMARY */.l.PRIMARY,
                                    className: (instance_detail_stage_meta_box_module_default())["listen-button"],
                                    disabled: (instance === null || instance === void 0 ? void 0 : instance.status) !== instance_status/* InstanceStatus.OPEN */.O.OPEN || (0,time_helper/* isDateInFuture */.ek)(instance === null || instance === void 0 ? void 0 : instance.variant.salesAttribute.saleFrom) || (0,time_helper/* isDateInPast */.OF)(instance === null || instance === void 0 ? void 0 : instance.variant.salesAttribute.saleTo) && !(instance === null || instance === void 0 ? void 0 : instance.ownerId) && !ownerWallet || (0,time_helper/* isDateInFuture */.ek)(instance === null || instance === void 0 ? void 0 : instance.saleStartDate),
                                    children: data === null || data === void 0 ? void 0 : data.buyButton.buttonText
                                }) : undefined
                            ]
                        })
                    })
                ]
            }),
            openModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(variant_detail_stage_meta_box_audio_video/* VariantDetailStageMetaBoxAudioVideo */.R, {
                type: (ref4 = samples === null || samples === void 0 ? void 0 : (ref = samples[0]) === null || ref === void 0 ? void 0 : ref.contentContentType) !== null && ref4 !== void 0 ? ref4 : "",
                onClose: function() {
                    return setModal(false);
                },
                title: (ref5 = samples === null || samples === void 0 ? void 0 : (ref1 = samples[0]) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref5 !== void 0 ? ref5 : "",
                url: (ref6 = samples === null || samples === void 0 ? void 0 : (ref2 = samples[0]) === null || ref2 === void 0 ? void 0 : ref2.url) !== null && ref6 !== void 0 ? ref6 : ""
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/instance-detail/instance-detail-stage/instance-detail-stage.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}































var InstanceDetailStage = function(param1) {
    var onButtonClick = param1.onButtonClick;
    var ref9, ref1, ref2;
    var instance = (0,redux/* useAppSelector */.CG)(function(state) {
        return state.productSlice;
    }).instance;
    var variant = (0,useFullVariantByIdSsr_hook/* useFullVariantByIdSsr */.Q)();
    var instanceMeta = useInstanceMetaByUrlSsr();
    var typoService = new typo_service/* TypoService */.$((0,useTypoContent_hook/* useTypoContent */.f)());
    var allowDimensionalCard = typoService.getAllowedDimensionalCardProductOwners();
    var owner = useInstanceDetailPage().owner;
    var language = (0,useCurrentLanguage_hook/* useCurrentLanguage */.U)();
    var ref3 = (0,useKeywords_hook/* useKeywords */.N)(), keywords = ref3.data;
    var publicRuntimeConfig = (0,config["default"])().publicRuntimeConfig;
    var resolvedKeywords = (keywords === null || keywords === void 0 ? void 0 : keywords.data) ? (0,useLookupTableData_hook/* mapLookupToLanguageHook */.g)(keywords === null || keywords === void 0 ? void 0 : keywords.data) : [];
    var getContentTypeByFileExtension = function(filename) {
        var fileExtension = filename === null || filename === void 0 ? void 0 : filename.split(".").pop();
        switch(fileExtension){
            case "jpg":
                return image_content_type_enum/* MediaContentType.JPG */.L.JPG;
            case "jpeg":
                return image_content_type_enum/* MediaContentType.JPEG */.L.JPEG;
            case "mp4":
                return image_content_type_enum/* MediaContentType.MP4 */.L.MP4;
            case "gif":
                return image_content_type_enum/* MediaContentType.GIF */.L.GIF;
            case "png":
                return image_content_type_enum/* MediaContentType.PNG */.L.PNG;
            default:
                return image_content_type_enum/* MediaContentType.JPG */.L.JPG;
        }
    };
    var covers = [];
    covers.push({
        name: instanceMeta.name,
        url: instanceMeta.image,
        variantId: variant.id,
        contentContentType: getContentTypeByFileExtension(instanceMeta.image),
        type: variant_image_type/* VariantImageType.COVER_ARTWORK */.W.COVER_ARTWORK
    });
    var dbCovers = (0,useFilterAttachments_hook/* default */.Z)(variant_image_type/* VariantImageType.COVER_ARTWORK */.W.COVER_ARTWORK, variant === null || variant === void 0 ? void 0 : variant.attachments);
    dbCovers.shift();
    covers = _toConsumableArray(covers).concat(_toConsumableArray(dbCovers));
    var ownerHref;
    if (instance && instance.ownerId) {
        var ref4;
        ownerHref = (0,generate_url_to_user_oan/* generateUrlToUserOan */.z)(instance === null || instance === void 0 ? void 0 : (ref4 = instance.owner) === null || ref4 === void 0 ? void 0 : ref4.username);
    }
    var _id, _id1, ref5, ref6, ref7, ref8, _mintingCount, _ownerUsername;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (instance_detail_stage_module_default())["instance-detail-top-wrapper"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (instance_detail_stage_module_default())["instance-detail-stage"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (instance_detail_stage_module_default())["instance-detail-stage-media-wrapper"],
                        children: covers && covers.length > 0 ? covers[0].contentContentType !== image_content_type_enum/* MediaContentType.MP4 */.L.MP4 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(stage_image_background/* default */.Z, {
                            url: covers[0].url,
                            alt: covers[0].name,
                            objectPosition: "center",
                            className: (instance_detail_stage_module_default())["stage-background"]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            autoPlay: true,
                            loop: true,
                            muted: true,
                            className: (instance_detail_stage_module_default())["stage-background"],
                            poster: (0,creatoken_posterUrl_resolver/* creatokenPosterUrlResolver */.m)((_id = variant.id) !== null && _id !== void 0 ? _id : -1),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: covers[0].url,
                                type: "video/mp4"
                            })
                        }) : undefined
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (instance_detail_stage_module_default())["instance-detail-stage-content-box"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, {
                                type: basic_card_variants_enum/* BasicCardVariants.VARIANT_DETAIL */.I.VARIANT_DETAIL,
                                className: (instance_detail_stage_module_default())["instance-detail-stage__carousel"],
                                items: covers === null || covers === void 0 ? void 0 : (ref9 = covers.map) === null || ref9 === void 0 ? void 0 : ref9.call(covers, function(param) {
                                    var id = param.id, name = param.name, urls = param.urls, contentContentType = param.contentContentType, url = param.url;
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((instance_detail_stage_module_default())["basic-card-image-wrapper-".concat(AspectRatio.WIDESCREEN)]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* Media */.pU, {
                                                contentType: contentContentType,
                                                alt: name,
                                                objectFit: "contain",
                                                src: (urls === null || urls === void 0 ? void 0 : urls.original) || url,
                                                posterUrl: (0,creatoken_posterUrl_resolver/* creatokenPosterUrlResolver */.m)((_id1 = variant.id) !== null && _id1 !== void 0 ? _id1 : -1),
                                                squared: true,
                                                initialLoad: true,
                                                dimensionalCard: allowDimensionalCard.includes(variant === null || variant === void 0 ? void 0 : (ref = variant.product) === null || ref === void 0 ? void 0 : ref.publisherNames.trim())
                                            })
                                        })
                                    }, id);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InstanceDetailStageMetaBox, {
                                genre: "",
                                ownerWallet: instance === null || instance === void 0 ? void 0 : instance.ownerWallet,
                                ownerUsername: instance === null || instance === void 0 ? void 0 : instance.ownerUsername,
                                keywords: variant && variant.keywords ? variant.keywords.map(function(keyword) {
                                    var res = resolvedKeywords === null || resolvedKeywords === void 0 ? void 0 : resolvedKeywords.find(function(word) {
                                        return keyword === word.id;
                                    });
                                    if (!res) return "";
                                    if (language === "de") return res.trans_de;
                                    else return res.trans_en;
                                }) : [],
                                title: (ref5 = instanceMeta === null || instanceMeta === void 0 ? void 0 : instanceMeta.name) !== null && ref5 !== void 0 ? ref5 : "",
                                author: (ref6 = (ref1 = instanceMeta === null || instanceMeta === void 0 ? void 0 : instanceMeta.attributes.find(function(attr) {
                                    return attr.trait_type === "Author";
                                })) === null || ref1 === void 0 ? void 0 : ref1.value) !== null && ref6 !== void 0 ? ref6 : "",
                                publisher: (ref7 = variant === null || variant === void 0 ? void 0 : (ref2 = variant.product) === null || ref2 === void 0 ? void 0 : ref2.publisherNames) !== null && ref7 !== void 0 ? ref7 : "",
                                release: instance && instance.saleStartDate ? new Date(instance.saleStartDate) : variant && variant.salesAttribute && variant.salesAttribute.saleFrom ? new Date(variant.salesAttribute.saleFrom) : undefined,
                                copies: (instance === null || instance === void 0 ? void 0 : instance.serialNumber) && (variant === null || variant === void 0 ? void 0 : variant.salesAttribute.mintingCount) ? "".concat((ref8 = instance === null || instance === void 0 ? void 0 : instance.serialNumber) !== null && ref8 !== void 0 ? ref8 : 0, " / ").concat((_mintingCount = variant === null || variant === void 0 ? void 0 : variant.salesAttribute.mintingCount) !== null && _mintingCount !== void 0 ? _mintingCount : 0) : "",
                                onButtonClick: onButtonClick
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((instance_detail_stage_module_default()).decButtonContainer),
                        children: instance && instance.ownerId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(stage_image_button_token/* StageImageButtonToken */.k, {
                            shadow: true,
                            image: "".concat(publicRuntimeConfig.backendURL, "api/user-profile/image/").concat(instance.ownerId),
                            hasLink: true,
                            href: ownerHref
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(stage_image_button_token/* StageImageButtonToken */.k, {
                            shadow: true,
                            image: creatoki/* default.src */.Z.src
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (instance_detail_stage_module_default())["owner-info"],
                        children: instance && (instance.ownerUsername || instance.ownerWallet) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (instance_detail_stage_module_default())["wallet-address-wrapper"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                    variant: typeography_variants_enum/* TypographyVariantsEnum.TABLE_TITLE */.H.TABLE_TITLE,
                                    children: owner
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(tool_tip/* default */.Z, {
                                    toolTip: (_ownerUsername = instance.ownerUsername) !== null && _ownerUsername !== void 0 ? _ownerUsername : instance.ownerWallet,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        variant: typeography_variants_enum/* TypographyVariantsEnum.TABLE_VALUE */.H.TABLE_VALUE,
                                        element: "span",
                                        children: instance.ownerUsername ? (0,truncate_string_helper/* default */.Z)(instance.ownerUsername, 4, 4) : (0,truncate_string_helper/* default */.Z)(instance.ownerWallet, 4, 4)
                                    })
                                })
                            ]
                        }) : null
                    })
                ]
            })
        ]
    });
};
InstanceDetailStage.dataHooks = [
    useInstanceDetailPage,
    useVariantDetailPage_hook/* useVariantDetailPage */.l,
    useFullVariantByIdSsr_hook/* useFullVariantByIdSsr */.Q,
    useInstanceMetaByUrlSsr
];

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.es.js
var pro_regular_svg_icons_index_es = __webpack_require__(2825);
// EXTERNAL MODULE: ./src/components/instance-detail/instance-detail-token-history-box/instance-detail-token-history-box.module.scss
var instance_detail_token_history_box_module = __webpack_require__(31897);
var instance_detail_token_history_box_module_default = /*#__PURE__*/__webpack_require__.n(instance_detail_token_history_box_module);
;// CONCATENATED MODULE: ./src/components/instance-detail/instance-detail-token-history-box/instance-detail-token-history-box.tsx










var TokenHistoryBox = function() {
    var instance = (0,hooks/* useAppSelector */.C)(function(state) {
        return state.productSlice.instance;
    });
    var data = useInstanceDetailPage();
    var getEtherscanLink = function() {
        var ref, ref1, ref2;
        var prefix = Number("1") === 5 ? "goerli." : "";
        var id = instance ? instance.creatoken ? instance.token : instance.id : undefined;
        var contract = instance ? instance.creatoken ? instance.contract : (ref = instance.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.salesAttribute) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contract) === null || ref2 === void 0 ? void 0 : ref2.contractAddress : undefined;
        return "https://".concat(prefix, "etherscan.io/token/").concat(contract, "?a=").concat(id);
    };
    if (data && instance && instance.minted) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion/* default */.Z, {
            label: data.tokenHistoryHeadline.headlineContent,
            onlyMobil: true,
            initialOpen: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (instance_detail_token_history_box_module_default())["token-history-box"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING4_BOLD */.H.HEADING4_BOLD,
                        element: "h4",
                        className: (instance_detail_token_history_box_module_default()).headline,
                        children: data.tokenHistoryHeadline.headlineContent
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: typeography_variants_enum/* TypographyVariantsEnum.BODY */.H.BODY,
                        element: "p",
                        className: (instance_detail_token_history_box_module_default())["description-body"],
                        children: data.tokenHistoryDescriptionLong.content
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (instance_detail_token_history_box_module_default())["token-history-box-link-wrapper"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_regular_svg_icons_index_es/* faExternalLinkAlt */.Xjp
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (instance_detail_token_history_box_module_default())["token-history-box-link"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: getEtherscanLink(),
                                    children: getEtherscanLink()
                                })
                            })
                        ]
                    })
                ]
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
/* harmony default export */ var instance_detail_token_history_box = (TokenHistoryBox);

// EXTERNAL MODULE: ./src/utils/_helper/enum-to-language-mapper.tsx
var enum_to_language_mapper = __webpack_require__(15487);
// EXTERNAL MODULE: ./src/utils/_enums/link-variants.enum.tsx
var link_variants_enum = __webpack_require__(11702);
// EXTERNAL MODULE: ./src/components/_shared/link/link.tsx
var link_link = __webpack_require__(46164);
// EXTERNAL MODULE: ./src/components/instance-detail/instance-detail-unlockables/instance-detail-unlockable-file/instance-detail-unlockable-file.module.scss
var instance_detail_unlockable_file_module = __webpack_require__(27916);
var instance_detail_unlockable_file_module_default = /*#__PURE__*/__webpack_require__.n(instance_detail_unlockable_file_module);
;// CONCATENATED MODULE: ./src/components/instance-detail/instance-detail-unlockables/instance-detail-unlockable-file/instance-detail-unlockable-file.tsx







var InstanceDetailUnlockableFile = function(param) {
    var link = param.link, name = param.name;
    if (link) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (instance_detail_unlockable_file_module_default())["instance-detail-unlockable-file"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: [
                    "fas",
                    "download"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                href: link,
                variant: link_variants_enum/* LinkVariants.STANDARD_LINK */.C.STANDARD_LINK,
                target: "_blank",
                className: (instance_detail_unlockable_file_module_default())["unlockable-link"],
                children: name
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: (instance_detail_unlockable_file_module_default())["instance-detail-unlockable-file"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (instance_detail_unlockable_file_module_default())["instance-detail-unlockable-file"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: [
                        "fas",
                        "download"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    children: name
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/instance-detail/instance-detail-unlockables/instance-detail-unlockable-image/instance-detail-unlockable-image.module.scss
var instance_detail_unlockable_image_module = __webpack_require__(39659);
var instance_detail_unlockable_image_module_default = /*#__PURE__*/__webpack_require__.n(instance_detail_unlockable_image_module);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/components/instance-detail/instance-detail-unlockables/instance-detail-unlockable-image/instance-detail-unlockable-image.tsx
function instance_detail_unlockable_image_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function instance_detail_unlockable_image_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                instance_detail_unlockable_image_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                instance_detail_unlockable_image_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}












var InstanceDetailUnlockableImage = function(props) {
    var ref, ref1, ref2, ref3;
    var data = (0,useGlobal_hook/* useGlobal */.O)();
    var downloadUnlockable = function() {
        var _ref = instance_detail_unlockable_image_asyncToGenerator(runtime_default().mark(function _callee() {
            var href, downloadName, res, indexOfExtension, extension, a;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        ;
                        _ctx.prev = 2;
                        if (!(props.contentType === image_content_type_enum/* MediaContentType.PNG */.L.PNG || props.contentType === image_content_type_enum/* MediaContentType.JPEG */.L.JPEG || props.contentType === image_content_type_enum/* MediaContentType.JPG */.L.JPG)) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 6;
                        return axios_default().get(props.imageUrl, {
                            responseType: "blob"
                        });
                    case 6:
                        res = _ctx.sent;
                        href = URL.createObjectURL(res.data);
                        _ctx.next = 11;
                        break;
                    case 10:
                        {
                            href = props.imageUrl;
                        }
                    case 11:
                        indexOfExtension = props.imageUrl.lastIndexOf(".");
                        extension = props.imageUrl.substring(indexOfExtension).toLowerCase();
                        downloadName = props.name + extension;
                        _ctx.next = 19;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](2);
                        href = props.imageUrl;
                    case 19:
                        a = document.createElement("a");
                        a.href = href;
                        if (downloadName) {
                            a.download = downloadName;
                        }
                        a.target = "_blank";
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    16
                ]
            ]);
        }));
        return function downloadUnlockable() {
            return _ref.apply(this, arguments);
        };
    }();
    var _variantId, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (instance_detail_unlockable_image_module_default())["unlockable-image"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* default */.ZP, {
                    classNameWrapper: (instance_detail_unlockable_image_module_default())["image-wrapper"],
                    className: (instance_detail_unlockable_image_module_default()).image,
                    src: props.imageUrl,
                    objectFit: "contain",
                    contentType: props.contentType,
                    posterUrl: (0,creatoken_posterUrl_resolver/* creatokenPosterUrlResolver */.m)((_variantId = props.variantId) !== null && _variantId !== void 0 ? _variantId : -1),
                    alt: props.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                    height: "10px"
                }),
                props.notDownloadable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                    disabled: true,
                    variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                    children: (ref4 = data === null || data === void 0 ? void 0 : (ref = data.buttons) === null || ref === void 0 ? void 0 : (ref1 = ref.download) === null || ref1 === void 0 ? void 0 : ref1.buttonText) !== null && ref4 !== void 0 ? ref4 : ""
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                    variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                    onClick: downloadUnlockable,
                    children: (ref5 = data === null || data === void 0 ? void 0 : (ref2 = data.buttons) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.download) === null || ref3 === void 0 ? void 0 : ref3.buttonText) !== null && ref5 !== void 0 ? ref5 : ""
                })
            ]
        })
    });
};
InstanceDetailUnlockableImage.defaultProps = {
    notDownloadable: false
};

// EXTERNAL MODULE: ./src/components/instance-detail/instance-detail-unlockables/instance-detail-unlockables.module.scss
var instance_detail_unlockables_module = __webpack_require__(24244);
var instance_detail_unlockables_module_default = /*#__PURE__*/__webpack_require__.n(instance_detail_unlockables_module);
;// CONCATENATED MODULE: ./src/components/instance-detail/instance-detail-unlockables/instance-detail-unlockables.tsx















var InstanceDetailUnlockables = function(props) {
    var breakpoint = (0,useBreakpoints_hook/* default */.Z)();
    var ref3 = useInstanceDetailPage(), unlockableDownloadsHeadline = ref3.unlockableDownloadsHeadline, unlockableFilesHeadline = ref3.unlockableFilesHeadline, unlockableHiresCoverHeadline = ref3.unlockableHiresCoverHeadline, instanceCoverHeadline = ref3.instanceCoverHeadline;
    var ref1 = (0,redux/* useAppSelector */.CG)(function(state) {
        var ref;
        return {
            userId: (ref = state.userSlice.user) === null || ref === void 0 ? void 0 : ref.id,
            walletId: state.blockchainSlice.walletId,
            instance: state.productSlice.instance,
            attachments: state.productSlice.attachments
        };
    }), userId = ref1.userId, walletId = ref1.walletId, instance = ref1.instance, attachments = ref1.attachments;
    var variant = (0,useFullVariantByIdSsr_hook/* useFullVariantByIdSsr */.Q)();
    var covers = (0,useFilterAttachments_hook/* default */.Z)(variant_image_type/* VariantImageType.COVER_ARTWORK */.W.COVER_ARTWORK, attachments);
    var unlockables = (0,useFilterAttachments_hook/* default */.Z)(variant_image_type/* VariantImageType.ADDITIONAL_FILES */.W.ADDITIONAL_FILES, attachments);
    if (!!instance && (!!userId && userId === instance.ownerId || walletId === instance.ownerWallet)) {
        var ref2;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion/* default */.Z, {
            label: (ref2 = unlockableDownloadsHeadline === null || unlockableDownloadsHeadline === void 0 ? void 0 : unlockableDownloadsHeadline.headlineContent) !== null && ref2 !== void 0 ? ref2 : "",
            onlyMobil: true,
            initialOpen: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (instance_detail_unlockables_module_default())["unlockables-wrapper"],
                children: [
                    breakpoint !== "mobile" && /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING3_BOLD */.H.HEADING3_BOLD,
                        element: "h2",
                        children: unlockableDownloadsHeadline.headlineContent
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (instance_detail_unlockables_module_default()).content,
                        children: [
                            unlockables && unlockables.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING4_BOLD */.H.HEADING4_BOLD,
                                        element: "h3",
                                        children: unlockableFilesHeadline.headlineContent
                                    }),
                                    unlockables === null || unlockables === void 0 ? void 0 : unlockables.map(function(param) {
                                        var url = param.url, name = param.name, id = param.id;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(InstanceDetailUnlockableFile, {
                                            name: name,
                                            link: url !== null && url !== void 0 ? url : ""
                                        }, id);
                                    })
                                ]
                            }),
                            covers && covers.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING4_BOLD */.H.HEADING4_BOLD,
                                        element: "h3",
                                        children: unlockableHiresCoverHeadline === null || unlockableHiresCoverHeadline === void 0 ? void 0 : unlockableHiresCoverHeadline.headlineContent
                                    }),
                                    covers === null || covers === void 0 ? void 0 : covers.map(function(param, index) {
                                        var urls = param.urls, contentContentType = param.contentContentType;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            style: index !== covers.length - 1 ? {
                                                marginBottom: "20px"
                                            } : undefined,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InstanceDetailUnlockableImage, {
                                                notDownloadable: userId !== (instance === null || instance === void 0 ? void 0 : instance.ownerId) && walletId !== (instance === null || instance === void 0 ? void 0 : instance.ownerWallet),
                                                variantId: variant.id,
                                                name: "variant-cover-art-".concat(variant.id),
                                                contentType: contentContentType,
                                                imageUrl: urls === null || urls === void 0 ? void 0 : urls.original
                                            })
                                        }, urls === null || urls === void 0 ? void 0 : urls.original);
                                    })
                                ]
                            }) : null,
                            props.instanceCoverArtUrl ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING4_BOLD */.H.HEADING4_BOLD,
                                        element: "h3",
                                        children: instanceCoverHeadline === null || instanceCoverHeadline === void 0 ? void 0 : instanceCoverHeadline.headlineContent
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InstanceDetailUnlockableImage, {
                                        notDownloadable: userId !== (instance === null || instance === void 0 ? void 0 : instance.ownerId) && walletId !== (instance === null || instance === void 0 ? void 0 : instance.ownerWallet),
                                        variantId: variant.id,
                                        name: "instance-cover-art-".concat(instance.id),
                                        contentType: enum_to_language_mapper/* EnumToLanguageMapper.urlWithExtensionToMediaContentType */.H.urlWithExtensionToMediaContentType(props.instanceCoverArtUrl),
                                        imageUrl: props.instanceCoverArtUrl
                                    }, props.instanceCoverArtUrl)
                                ]
                            }) : null
                        ]
                    })
                ]
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};

// EXTERNAL MODULE: ./src/components/variant-detail/product-attributes/originator-list/originator-list.tsx
var originator_list = __webpack_require__(10747);
// EXTERNAL MODULE: ./src/components/variant-detail/publisher-info-box/publisher-info-box.tsx
var publisher_info_box = __webpack_require__(81105);
// EXTERNAL MODULE: ./src/components/variant-detail/variant-attributes/legal-box/legal-box.tsx
var legal_box = __webpack_require__(19789);
// EXTERNAL MODULE: ./src/components/variant-detail/variant-attributes/product-artifact-box/product-artifact-box.tsx
var product_artifact_box = __webpack_require__(90869);
// EXTERNAL MODULE: ./src/components/variant-detail/variant-attributes/sample-box/sample-box.tsx
var sample_box = __webpack_require__(45316);
// EXTERNAL MODULE: ./src/components/variant-detail/variant-attributes/unlockables-box/unlockables-box.tsx
var unlockables_box = __webpack_require__(41865);
// EXTERNAL MODULE: ./src/redux/slices/user-slice.tsx + 1 modules
var user_slice = __webpack_require__(1305);
// EXTERNAL MODULE: ./src/utils/_helper/generate-url-to-details-page-helper.ts
var generate_url_to_details_page_helper = __webpack_require__(49352);
// EXTERNAL MODULE: ./src/utils/_hooks/useFilterAttachmentsSsr.hook.ts
var useFilterAttachmentsSsr_hook = __webpack_require__(31416);
// EXTERNAL MODULE: ./src/views/instance-detail-page/instance-detail-page.module.scss
var instance_detail_page_module = __webpack_require__(60603);
var instance_detail_page_module_default = /*#__PURE__*/__webpack_require__.n(instance_detail_page_module);
;// CONCATENATED MODULE: ./src/views/instance-detail-page/instance-detail-page.tsx
function instance_detail_page_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function instance_detail_page_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return instance_detail_page_arrayLikeToArray(arr);
}
function instance_detail_page_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function instance_detail_page_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function instance_detail_page_toConsumableArray(arr) {
    return instance_detail_page_arrayWithoutHoles(arr) || instance_detail_page_iterableToArray(arr) || instance_detail_page_unsupportedIterableToArray(arr) || instance_detail_page_nonIterableSpread();
}
function instance_detail_page_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return instance_detail_page_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return instance_detail_page_arrayLikeToArray(o, minLen);
}







































var InstanceDetailPage = function() {
    var ref17, ref1, ref2, ref3, ref4;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,client_router.useRouter)();
    var data = useInstanceDetailPage();
    var variantData = (0,useVariantDetailPage_hook/* useVariantDetailPage */.l)();
    var variant = (0,useFullVariantByIdSsr_hook/* useFullVariantByIdSsr */.Q)();
    var ref5 = (0,useContextSSr_hook/* useContextSsr */._)(), host = ref5.host, locale = ref5.locale;
    var protocol = (host === null || host === void 0 ? void 0 : host.includes("creatokia")) ? "https://" : "http://";
    var ref6, ref7, ref8, ref9;
    var path = (0,generate_url_to_details_page_helper/* generateUrlToDetailedPage */.e)((ref6 = variant === null || variant === void 0 ? void 0 : variant.productName) !== null && ref6 !== void 0 ? ref6 : "", (ref7 = variant === null || variant === void 0 ? void 0 : variant.title) !== null && ref7 !== void 0 ? ref7 : "", (ref8 = variant === null || variant === void 0 ? void 0 : variant.productId) !== null && ref8 !== void 0 ? ref8 : "", (ref9 = variant === null || variant === void 0 ? void 0 : variant.id) !== null && ref9 !== void 0 ? ref9 : -1, parseInt(router.query.instanceId));
    var jwt = (0,redux/* useAppSelector */.CG)(function(state) {
        return {
            jwt: state.authentification.jwt
        };
    }).jwt;
    var ref10 = (0,redux/* useAppSelector */.CG)(function(state) {
        var ref;
        return {
            userId: (ref = state.userSlice.user) === null || ref === void 0 ? void 0 : ref.id,
            walletId: state.blockchainSlice.walletId,
            instance: state.productSlice.instance,
            attachments: state.productSlice.attachments
        };
    }), userId = ref10.userId, walletId = ref10.walletId, instance = ref10.instance, attachments = ref10.attachments;
    var covers = (0,useFilterAttachmentsSsr_hook/* default */.Z)(variant_image_type/* VariantImageType.COVER_ARTWORK */.W.COVER_ARTWORK, variant === null || variant === void 0 ? void 0 : variant.attachments);
    var instanceMeta = useInstanceMetaByUrlSsr();
    var instanceMetaAttributes = (instanceMeta === null || instanceMeta === void 0 ? void 0 : (ref17 = instanceMeta.attributes) === null || ref17 === void 0 ? void 0 : ref17.map(function(attr) {
        return {
            label: attr.trait_type,
            value: attr.value
        };
    })) || {};
    (0,react.useEffect)(function() {
        dispatch((0,user_slice/* checkGeoblocking */.Re)());
        dispatch((0,redux/* getEthereumPriceData */.Mj)());
    }, []);
    (0,react.useEffect)(function() {
        dispatch((0,redux/* fetchInstance */.JI)(parseInt(router.query.instanceId)));
    }, [
        router.query.instanceId
    ]);
    (0,react.useEffect)(function() {
        dispatch((0,redux/* fetchAttachments */.u7)(variant.id));
        return function() {
            dispatch((0,redux/* setAttachments */.HV)());
        };
    }, [
        jwt
    ]);
    var ref11 = (0,react.useState)(false), openModal = ref11[0], setModal = ref11[1];
    var ref12 = (0,react.useState)(undefined), sample1 = ref12[0], setSample = ref12[1];
    var handleOpenSampleModal = function(sample) {
        setSample(sample);
        setModal(true);
    };
    var salesBoxRef = /*#__PURE__*/ react.createRef();
    var scrollIntoView = function() {
        return salesBoxRef.current.scrollIntoView({
            behavior: "smooth"
        });
    };
    var unlockableBox = /*#__PURE__*/ (0,jsx_runtime.jsx)(unlockables_box/* default */.Z, {});
    var isOwner = false;
    if (!!instance && (!!userId && userId === instance.ownerId || walletId === instance.ownerWallet)) {
        unlockableBox = undefined;
        isOwner = true;
    }
    var ref13, ref14, ref15, ref16;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta_tags_resolver/* MetaTagsResolver */.H, {
                tags: {
                    metaOgTitle: variant === null || variant === void 0 ? void 0 : variant.title,
                    metaTagKeywords: "Creatokia, NFT, Crypto",
                    metaTagTitle: variant === null || variant === void 0 ? void 0 : variant.title,
                    metaTagDescription: variant === null || variant === void 0 ? void 0 : variant.variantDescriptionSEO,
                    metaTagCanonical: host,
                    metaOgDescription: variant === null || variant === void 0 ? void 0 : variant.variantDescriptionShort,
                    metaOgUrl: "".concat(protocol).concat(host, "/").concat(locale !== null && locale !== void 0 ? locale : "en").concat(path),
                    metaTwitterSite: "".concat(protocol).concat(host, "/").concat(locale !== null && locale !== void 0 ? locale : "en").concat(path),
                    metaOgSiteName: "Creatokia",
                    MetaOgImage: {
                        url: covers === null || covers === void 0 ? void 0 : (ref1 = covers[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.urls) === null || ref2 === void 0 ? void 0 : ref2.original,
                        id: (ref13 = covers === null || covers === void 0 ? void 0 : (ref3 = covers[0]) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref13 !== void 0 ? ref13 : -1,
                        alternativeText: variant === null || variant === void 0 ? void 0 : variant.title,
                        name: variant === null || variant === void 0 ? void 0 : variant.title,
                        width: 0,
                        height: 0,
                        caption: ""
                    },
                    metaNoFollow: true,
                    metaNoIndex: true
                },
                languageAlternates: [
                    {
                        hrefLang: "en",
                        href: "".concat(protocol).concat(host, "/en").concat(path)
                    },
                    {
                        hrefLang: "de",
                        href: "".concat(protocol).concat(host, "/de").concat(path)
                    }
                ],
                locale: locale === null || locale === void 0 ? void 0 : locale.toUpperCase(),
                localeAlternate: locale === "de" ? "EN" : "DE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(header_footer_wrapper/* HeaderFooterWrapper */.u, {
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(default_header/* DefaultHeader */.y, {
                    availableLanguages: data === null || data === void 0 ? void 0 : data.localizations
                }),
                stage: /*#__PURE__*/ (0,jsx_runtime.jsx)(InstanceDetailStage, {
                    onButtonClick: scrollIntoView
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (instance_detail_page_module_default())["instance-detail-content-container"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumbs/* default */.Z, {
                                breadcrumbs: [
                                    {
                                        name: data === null || data === void 0 ? void 0 : data.breadcrumbHome,
                                        href: "/"
                                    },
                                    {
                                        name: data === null || data === void 0 ? void 0 : data.breadcrumbDigitalOriginals,
                                        href: "/digital-originals"
                                    },
                                    {
                                        name: variant.title,
                                        href: (0,generate_url_to_details_page_helper/* generateUrlToDetailedPage */.e)(variant.productName, variant.title, variant.productId, variant.id)
                                    },
                                    {
                                        name: router.query.instanceId,
                                        href: ""
                                    }
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (instance_detail_page_module_default())["accordion-wrapper"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (instance_detail_page_module_default())["sales-box-container"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion/* default */.Z, {
                                            label: variantData.variantDescription.headlineContent,
                                            onlyMobil: true,
                                            initialOpen: false,
                                            reverseContent: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (instance_detail_page_module_default())["sales-box"],
                                                    ref: salesBoxRef,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sales_box, {
                                                        salesType: sales_type/* SalesType.FIXED_PRICE */.r.FIXED_PRICE
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                    variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING3_BOLD */.H.HEADING3_BOLD,
                                                    element: "h3",
                                                    children: variantData === null || variantData === void 0 ? void 0 : variantData.variantDescription.headlineContent
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                    className: (instance_detail_page_module_default()).description,
                                                    children: instanceMeta.description
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(instance_detail_token_history_box, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (instance_detail_page_module_default())["product-details"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion/* default */.Z, {
                                            label: variantData === null || variantData === void 0 ? void 0 : variantData.variantAttributes.headlineContent,
                                            onlyMobil: true,
                                            initialOpen: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                                    variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING3_BOLD */.H.HEADING3_BOLD,
                                                    element: "h3",
                                                    children: variantData === null || variantData === void 0 ? void 0 : variantData.variantAttributes.headlineContent
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                                                    height: "40px"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (instance_detail_page_module_default())["instance-info-container"],
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(product_artifact_box/* default */.Z, {
                                                                    isOwner: isOwner,
                                                                    instanceId: instance === null || instance === void 0 ? void 0 : instance.id
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sample_box/* default */.Z, {
                                                                    onClick: handleOpenSampleModal
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(legal_box/* default */.Z, {})
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(generic_attribute_box, {
                                                                headline: variantData === null || variantData === void 0 ? void 0 : variantData.additionalAttributes.headlineContent,
                                                                attributes: instanceMetaAttributes
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InstanceDetailUnlockables, {
                                        instanceCoverArtUrl: instanceMeta.image
                                    })
                                ]
                            }),
                            unlockableBox,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (instance_detail_page_module_default()).originatorList,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(originator_list/* default */.Z, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(publisher_info_box/* default */.Z, {
                        className: (instance_detail_page_module_default())["publisher-desktop"]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(more_instances_box, {}),
                    openModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(variant_detail_stage_meta_box_audio_video/* VariantDetailStageMetaBoxAudioVideo */.R, {
                        type: (ref14 = sample1 === null || sample1 === void 0 ? void 0 : sample1.contentContentType) !== null && ref14 !== void 0 ? ref14 : "",
                        title: (ref15 = sample1 === null || sample1 === void 0 ? void 0 : sample1.name) !== null && ref15 !== void 0 ? ref15 : "",
                        onClose: function() {
                            return setModal(false);
                        },
                        url: (ref16 = sample1 === null || sample1 === void 0 ? void 0 : (ref4 = sample1.urls) === null || ref4 === void 0 ? void 0 : ref4.original) !== null && ref16 !== void 0 ? ref16 : "",
                        id: variant === null || variant === void 0 ? void 0 : variant.id
                    })
                ]
            })
        ]
    });
};
InstanceDetailPage.dataHooks = instance_detail_page_toConsumableArray(header_footer_wrapper/* HeaderFooterWrapper.dataHooks */.u.dataHooks).concat([
    useInstanceDetailPage,
    useVariantDetailPage_hook/* useVariantDetailPage */.l,
    useFooter_hook/* useFooter */.T,
    useAccountManageWallet_hook/* useAccountManageWallet */.Z
], instance_detail_page_toConsumableArray(meta_tags_resolver/* MetaTagsResolver.dataHooks */.H.dataHooks), [
    useFullVariantByIdSsr_hook/* useFullVariantByIdSsr */.Q,
    useContextSSr_hook/* useContextSsr */._
]);

;// CONCATENATED MODULE: ./src/pages/products/[productVariantIdentifier]/[instanceId].tsx



var InstanceDetail = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InstanceDetailPage, {});
};
var __N_SSP = true;
/* harmony default export */ var _instanceId_ = (InstanceDetail);


/***/ }),

/***/ 18841:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var truncateString = function(str, maxLettersBeforeTruncate, maxLettersAfterTruncate) {
    if (maxLettersBeforeTruncate + maxLettersAfterTruncate >= str.length) {
        return str;
    } else {
        return str.substring(0, maxLettersBeforeTruncate) + "..." + str.substring(str.length - maxLettersAfterTruncate);
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (truncateString);


/***/ }),

/***/ 38434:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","checkbox-wrapper":"checkbox_checkbox-wrapper__yTOgu","container":"checkbox_container__cO6DU","checkmark":"checkbox_checkmark__leBLq","disabled":"checkbox_disabled__AuzbX","error":"checkbox_error__TTIy1"};

/***/ }),

/***/ 76012:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","attribute-column":"generic-attribute-box_attribute-column__VWgLt","headline":"generic-attribute-box_headline__2USoa"};

/***/ }),

/***/ 76291:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","fixed-price-sale":"cancel-resale-box_fixed-price-sale__uD4HD","fixed-price-left-wrapper":"cancel-resale-box_fixed-price-left-wrapper__ztKfy","on-sale-for":"cancel-resale-box_on-sale-for__ycgdr","main-price":"cancel-resale-box_main-price__ap_v1","secondary-price":"cancel-resale-box_secondary-price___Hq8u","secondary-resale-price":"cancel-resale-box_secondary-resale-price__m11eD","tax-note":"cancel-resale-box_tax-note__d3OH3","fixed-price-right-wrapper":"cancel-resale-box_fixed-price-right-wrapper__EqSjd","geo-ip-error":"cancel-resale-box_geo-ip-error__ndVk2","fixed-price-buy":"cancel-resale-box_fixed-price-buy__Ffn5d","price":"cancel-resale-box_price__xRK5S","confirm-cancel-sale":"cancel-resale-box_confirm-cancel-sale__SIy03","cancel-sale-actions":"cancel-resale-box_cancel-sale-actions__iUd09","cancel-button":"cancel-resale-box_cancel-button__6GYXD","connect-wallet-wrapper":"cancel-resale-box_connect-wallet-wrapper__08VNK"};

/***/ }),

/***/ 90870:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","connect-wallet-wrapper":"sales-box-connect-wallet_connect-wallet-wrapper__4IrCl","button-wrapper":"sales-box-connect-wallet_button-wrapper__fwlT5","wallet-connect-button":"sales-box-connect-wallet_wallet-connect-button__oDiID"};

/***/ }),

/***/ 85535:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","fixed-price-sale":"fixed-price-sale_fixed-price-sale__BA3nY","fixed-price-left-wrapper":"fixed-price-sale_fixed-price-left-wrapper__0RJP6","sales-type":"fixed-price-sale_sales-type__Tf1xF","price-wrapper":"fixed-price-sale_price-wrapper__8f9xL","fixed-price-right-wrapper":"fixed-price-sale_fixed-price-right-wrapper__GWYxA","fixed-price-buy":"fixed-price-sale_fixed-price-buy__c22dp","geo-ip-error":"fixed-price-sale_geo-ip-error__o6WQf","transaction-fee-box":"fixed-price-sale_transaction-fee-box__zVac6"};

/***/ }),

/***/ 37261:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","minting-box":"minting-box_minting-box__dfp3_","wallet-connected-text":"minting-box_wallet-connected-text__Vo3R5","bold-text":"minting-box_bold-text__f19So","error-message":"minting-box_error-message__8bG_r","mint-nft-button":"minting-box_mint-nft-button__fkaXm","create-wallet-button":"minting-box_create-wallet-button__aLEPv"};

/***/ }),

/***/ 35170:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","not-available-nft":"not-available-nft_not-available-nft__kM44g","lower-wrapper":"not-available-nft_lower-wrapper__ux7eY","not-available-box":"not-available-nft_not-available-box__3qWwa","not-available-headline":"not-available-nft_not-available-headline__lq3Eg","first-button":"not-available-nft_first-button__LgAYw","last-button":"not-available-nft_last-button__zzU7d"};

/***/ }),

/***/ 96238:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","owner-options":"owner-options_owner-options__ejPle","owner-options-lower-wrapper":"owner-options_owner-options-lower-wrapper__l_UZ3","owner-options-wallet-connect":"owner-options_owner-options-wallet-connect__MKHZy"};

/***/ }),

/***/ 78839:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","sales-box":"sales-box_sales-box__Nltot","header":"sales-box_header__qkU_5","price-info-box":"sales-box_price-info-box__HhWRt","sales-title-inner":"sales-box_sales-title-inner__0wqKs","sales-title":"sales-box_sales-title__oCAF8","main-content":"sales-box_main-content__wrPZp","anchor":"sales-box_anchor__ugucP"};

/***/ }),

/***/ 824:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","sell-nft-box":"sell-nft-box_sell-nft-box__ewzXc","sell-nft-box-left-wrapper":"sell-nft-box_sell-nft-box-left-wrapper___Bh3f","sell-nft-box-right-wrapper":"sell-nft-box_sell-nft-box-right-wrapper__kTLkA","confirm-sale-button":"sell-nft-box_confirm-sale-button__41BFz","lower-input":"sell-nft-box_lower-input__ivalY","exchange-rate":"sell-nft-box_exchange-rate__diQF2","sell-actions":"sell-nft-box_sell-actions__M1eIJ","abort-sale-button":"sell-nft-box_abort-sale-button__l91EB","confirmation-box":"sell-nft-box_confirmation-box__USEpi","connect-wallet-wrapper":"sell-nft-box_connect-wallet-wrapper__laJ7O"};

/***/ }),

/***/ 43067:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stage-image-button-token":"stage-image-button-token_stage-image-button-token__NZS_U","stage-image-button-token-link":"stage-image-button-token_stage-image-button-token-link__aBRfn","editButton":"stage-image-button-token_editButton__E4dxD"};

/***/ }),

/***/ 21058:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","variant-detail-stage-meta-box":"instance-detail-stage-meta-box_variant-detail-stage-meta-box__i9ziG","owner-wallet-id":"instance-detail-stage-meta-box_owner-wallet-id__Fmjpz","variant-detail-stage-meta-box__keywords":"instance-detail-stage-meta-box_variant-detail-stage-meta-box__keywords__AMzGO","listen-button":"instance-detail-stage-meta-box_listen-button__yOLFg","button-box":"instance-detail-stage-meta-box_button-box__Dk6UD","instance-title":"instance-detail-stage-meta-box_instance-title__4UFwU","table":"instance-detail-stage-meta-box_table__jsyzM","variant-detail-stage-meta-box-infos":"instance-detail-stage-meta-box_variant-detail-stage-meta-box-infos__tKw_l"};

/***/ }),

/***/ 2236:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","instance-detail-stage":"instance-detail-stage_instance-detail-stage__YG1zq","instance-detail-stage-media-wrapper":"instance-detail-stage_instance-detail-stage-media-wrapper__KzNOT","stage-background":"instance-detail-stage_stage-background__hoWxu","instance-detail-stage-content-box":"instance-detail-stage_instance-detail-stage-content-box__lH7MH","instance-detail-stage__carousel":"instance-detail-stage_instance-detail-stage__carousel__qmBGN","decButtonContainer":"instance-detail-stage_decButtonContainer__X97Z6","wallet-address-wrapper":"instance-detail-stage_wallet-address-wrapper___LeHW","wallet-address":"instance-detail-stage_wallet-address__yJac5","owner-info":"instance-detail-stage_owner-info__KOuXR"};

/***/ }),

/***/ 31897:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","token-history-box":"instance-detail-token-history-box_token-history-box__f5lD_","description-body":"instance-detail-token-history-box_description-body__9Xccw","token-history-box-link-wrapper":"instance-detail-token-history-box_token-history-box-link-wrapper__AGiik","token-history-box-link":"instance-detail-token-history-box_token-history-box-link__YNK5F","headline":"instance-detail-token-history-box_headline__bQNJE"};

/***/ }),

/***/ 27916:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"instance-detail-unlockable-file":"instance-detail-unlockable-file_instance-detail-unlockable-file__oSBbw","unlockable-link":"instance-detail-unlockable-file_unlockable-link__2D6AO"};

/***/ }),

/***/ 39659:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"unlockable-image":"instance-detail-unlockable-image_unlockable-image__SYwzX","image-wrapper":"instance-detail-unlockable-image_image-wrapper__s2zYr","image":"instance-detail-unlockable-image_image__Fu2xN"};

/***/ }),

/***/ 24244:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","unlockables-wrapper":"instance-detail-unlockables_unlockables-wrapper__Qw_Dv","content":"instance-detail-unlockables_content__gOYwt"};

/***/ }),

/***/ 60603:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","body-container":"instance-detail-page_body-container__21DV_","right-wrapper":"instance-detail-page_right-wrapper__PhPIy","left-wrapper":"instance-detail-page_left-wrapper__3khpt","publisher-desktop":"instance-detail-page_publisher-desktop__RyZdN","publisher-mobile":"instance-detail-page_publisher-mobile__bXTpj","instance-detail-content-container":"instance-detail-page_instance-detail-content-container__flAsI","accordion-wrapper":"instance-detail-page_accordion-wrapper__6G0jP","product-details":"instance-detail-page_product-details__VMSOw","sales-box-container":"instance-detail-page_sales-box-container__NCPOd","instance-info-container":"instance-detail-page_instance-info-container__8ajqG","sales-box":"instance-detail-page_sales-box__YTTuJ","description":"instance-detail-page_description__RyoeR"};

/***/ }),

/***/ 25934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,4577,9866,6586,8760,6067,3089,855,725,9123,2888,179], function() { return __webpack_exec__(84266); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);